export const translations = {
  IT: {
    gf45Porte: '4-5 porte',
    gfAllInclusive: 'All Inclusive',
    gfAndataRitorno: 'Andata e ritorno',
    gfAutomatico: 'Automatico',
    gfBedAndBreakfast: 'Bed and Breakfast',
    gfCena: 'Cena',
    gfCentrale: 'Centrale',
    gfCompact: 'Compact',
    gfCorridoio: 'Corridoio',
    gfEconomy: 'Economy',
    gfFinestrino: 'Finestrino',
    gfFormatoData: 'Formato gg/mm/aaaa',
    gfFullSize: 'Full size',
    gfIntermediate: 'Intermediate',
    gfLuxury: 'Luxury',
    gfManuale: 'Manuale',
    gfMezzaPensione: 'Mezza pensione',
    gfMini: 'Mini',
    gfNo: 'No',
    gfNonPrecedentePartenza: 'Non può essere precedente alla partenza',
    gfNonSpecificato: 'Non specificato',
    gfPensioneCompleta: 'Pensione completa',
    gfPranzo: 'Pranzo',
    gfPremium: 'Premium',
    gfSi: 'Si',
    gfSolaAndata: 'Sola andata',
    gfSoloNumeri: 'Solo numeri',
    gfSoloStanza: 'Solo stanza',
    gfStandard: 'Standard',
    gfSuv: 'Suv',
    gfVan: 'Van',
    mxAllInclusive: 'All Inclusive',
    mxBedAndBreakfast: 'Bed and Breakfast',
    mxCenaInclusa: 'Cena Inclusa',
    mxCoeffDistanza: 'Coefficiente Distanza',
    mxCoeffDurata: 'Coefficiente Durata',
    mxCoeffScostamento: 'Coefficiente Scostamento',
    mxGruppoBase: 'Base',
    mxGruppoCorporate: 'Corporate',
    mxGruppoLivelliHotel: 'Livelli Hotel Program',
    mxGruppoTrattamento: 'Trattamento',
    mxLivello0: 'Livello 0',
    mxLivello1: 'Livello 1',
    mxLivello2: 'Livello 2',
    mxLivello3: 'Livello 3',
    mxMezzaPensione: 'Mezza Pensione',
    mxPensioneCompleta: 'Pensione Completa',
    mxPranzoIncluso: 'Pranzo Incluso',
    mxRoomOnly: 'Room Only',
    mxTariffaAgenzia: 'Tariffa Agenzia',
    mxTariffaCliente: 'Tariffa Cliente',
    mxTariffaPubblica: 'Tariffa Pubblica',
    pfPreset24h: 'Ultime 24h',
    pfPreset30Giorni: 'Ultimi 30 giorni',
    pfPreset6h: 'Ultime 6h',
    pfPreset7Giorni: 'Ultimi 7 giorni',
    pfPresetUltimaOra: 'Ultima ora',
    pfStatoAttenzione: 'Attenzione',
    pfStatoCritico: 'Critico',
    pfStatoNormale: 'Normale',
    pfStepCompletato: 'Completato',
    admAbilitazioneArrivoEntro: 'Abilitazione arrivo entro',
    admAbilitazioneArrivoEntroDesc:
      "Abilita l'impostazione dell'ora di partenza dei servizi a 00:01 se non è indicata ma è presente l'indicazione di arrivo entro...",
    admAbilitazioneAtlante: 'Abilitazione Atlante',
    admAbilitazioneAtlanteDesc: "Abilita l'utilizzo di Atlante.",
    admAbilitazioneB4B: 'Abilitazione B4B',
    admAbilitazioneB4BDesc: "Abilita l'integrazione con il sistema B4B",
    admAbilitazioneCarnet: 'Abilitazione carnet',
    admAbilitazioneCarnetDesc: "Abilita l'utilizzo dei carnet.",
    admAbilitazioneMidOffice: 'Abilitazione Mid Office',
    admAbilitazioneMidOfficeDesc: "Abilita l'utilizzo di Mid Office.",
    admAbilitazioneRimborsabile: 'Abilitazione gestione rimborsabile',
    admAbilitazioneRimborsabileDesc: 'Abilita la gestione dei treni rimborsabili o meno.',
    admBloccaEmailErroreOperatori: 'Blocca invio email di errore agli operatori',
    admBloccaEmailErroreOperatoriDesc: "Blocca l'invio di email di errore agli operatori",
    admCodiceMastroCliente: 'Codice Mastro Cliente',
    admCodiceMastroClienteDesc:
      'Codice mastro per identificare il cliente (es: 20 1 2 127, il 20 è il mastro)',
    admCodiceOperatore: 'Codice Operatore',
    admCodiceOperatoreDesc: 'Codice operatore per ricerca su ATP Tabelle generiche',
    admCodiceProvenienza: 'Codice Provenienza',
    admCodiceProvenienzaDesc: 'Codice provenienza per ATP Tabelle biglietti',
    admCodiceSocieta: 'Codice Società',
    admCodiceSocietaDesc: 'Codice univoco per identificare la società',
    admCodiceTomcat: 'Codice Tomcat',
    admCodiceTomcatDesc: 'Codice del server Tomcat associato',
    admConfigurazioneEmailReport: 'Configurazione Email Report',
    admConfigurazioneEmailReportDesc:
      'Configurazione JSON per le credenziali e impostazioni di invio email dalla piattaforma. Esempio: {"host": "smtp.gmail.com", "port": 587, "secure": false, "auth": {"user": "email@example.com", "pass": "password"}}',
    admElencoEmailCCReport: 'Elenco Email in CC a report (separati da virgola)',
    admElencoEmailCCReportDesc: 'Lista email in copia per i report (separate da virgola)',
    admDominioEmailOperatore: 'Dominio email operatori',
    admDominioEmailOperatoreDesc:
      'Dominio fisso (es. bcdtravel.it) delle email operatore nelle segnalazioni. Vuoto: email completa.',
    admEstrapolazioneCampi1a10: 'Abilitazione estrapolazione AI campi 1 a 10',
    admEstrapolazioneCampi1a10Desc: "Abilita l'estrapolazione AI per i campi 1-10",
    admFlussoRichiestaInfoGeneriche: 'Abilitazione flusso richiesta informazioni generiche',
    admFlussoRichiestaInfoGenericheDesc: 'Abilita il flusso richiesta informazioni generiche',
    admGestioneAuto: 'Abilitazione gestione auto',
    admGestioneAutoDesc: 'Abilita la gestione delle auto a noleggio.',
    admGestioneGruppiPasseggeri: 'Abilitazione gestione gruppi passeggeri',
    admGestioneGruppiPasseggeriDesc: 'Abilita la gestione dei gruppi di passeggeri.',
    admGoogleApiKey: 'Google API Key',
    admGoogleApiKeyDesc: 'Chiave API per i servizi Google',
    admInviaNotificaFormDati: 'Invia notifica di completamento form dati',
    admInviaNotificaFormDatiDesc: 'Invia notifica di completamento form dati',
    admInvioEmailRiassuntivoOperatore: 'Abilitazione invio email riassuntivo operatore',
    admInvioEmailRiassuntivoOperatoreDesc: "Abilita l'invio di email riassuntive agli operatori",
    admLetturaAllegatiEmail: 'Abilitazione della lettura degli allegati email',
    admLetturaAllegatiEmailDesc: 'Abilita la lettura degli allegati email',
    admLetturaOggettoEmail: 'Abilitazione lettura oggetto email',
    admLetturaOggettoEmailDesc:
      "Abilita la lettura e l'analisi dell'oggetto dell'email e l'eventuale merge con i dati estratti dal corpo del messaggio.",
    admLetturaStoricoViaggiatore: 'Abilitazione lettura dello storico del profilo viaggiatore',
    admLetturaStoricoViaggiatoreDesc: 'Abilita la lettura dello storico del profilo viaggiatore',
    admNomeDbB4B: 'Nome DB B4B',
    admNomeDbB4BDesc: 'Nome del database B4B',
    admNomeDbDinamico: 'Nome DB Dinamico',
    admNomeDbDinamicoDesc: 'Nome del database Dinamico',
    admNomeDesc: 'Nome identificativo della società',
    admNumeroMassimoMessaggiAI: 'Numero massimo messaggi AI',
    admNumeroMassimoMessaggiAIDesc: 'Numero massimo di messaggi AI consentiti (default: 5)',
    admPasswordB4B: 'Password B4B',
    admPasswordB4BDesc: 'Password per il database B4B (password criptata con script esterno)',
    admPasswordDbDinamico: 'Password DB Dinamico',
    admPasswordDbDinamicoDesc:
      'Password per il database Dinamico (password criptata con script esterno)',
    admPasswordJavaWsDinamico: 'Password Java WS Dinamico',
    admPasswordJavaWsDinamicoDesc: 'Password per DynJavaWS (password criptata con script esterno)',
    admPasswordWS: 'Password WS',
    admPasswordWSDesc:
      "Password per l'autenticazione ai web services (password criptata con script esterno)",
    admPortaB4B: 'Porta B4B',
    admPortaB4BDesc: 'Porta del database B4B',
    admPortaDbDinamico: 'Porta DB Dinamico',
    admPortaDbDinamicoDesc: 'Porta del database Dinamico',
    admPresaInCarico: 'Abilitazione "presa in carico"',
    admPresaInCaricoDesc: 'Abilita la funzionalità di poter prendere in carico una conversazione',
    admPuliziaPPI: 'Abilitazione pulizia PPI',
    admPuliziaPPIDesc: 'Abilita la pulizia delle informazioni personali identificabili (PPI).',
    admResocontoOperatore: 'Abilitazione resoconto operatore',
    admResocontoOperatoreDesc:
      "Abilita la creazione del resoconto della trasferta da inviare all'operatore in caso positivo e in caso di errore.",
    admSaltoRicercaTreni: 'Salto ricerca treni su dinamico',
    admSaltoRicercaTreniDesc: 'Salta la ricerca treni su dinamico',
    admSanitizzazioneEmailSenzaAI: 'Abilitazione sanitizzazione email senza AI',
    admSanitizzazioneEmailSenzaAIDesc: "Abilita la sanitizzazione dell'email senza usare AI",
    admTargetPacchettoDinamico: 'Target Pacchetto Dinamico',
    admTargetPacchettoDinamicoDesc: 'Target del pacchetto dinamico (Test/Production)',
    admTelefonoWhatsapp: 'Telefono Whatsapp',
    admTelefonoWhatsappDesc: 'Numero di telefono per WhatsApp',
    admUrlAtlante: 'Url Atlante',
    admUrlAtlanteDesc: 'URL del servizio Atlante per le prenotazioni',
    admUrlB4B: 'Url B4B',
    admUrlB4BDesc: 'URL del database B4B',
    admUrlDbDinamico: 'Url DB Dinamico',
    admUrlDbDinamicoDesc: 'URL del database Dinamico',
    admUrlDinamicoPhp: 'Url Dinamico PHP',
    admUrlDinamicoPhpDesc: 'URL del servizio PHP Dinamico',
    admUrlJavaWsDinamico: 'Url Java WS Dinamico',
    admUrlJavaWsDinamicoDesc: 'URL del servizio Java WS Dinamico',
    admUtenteB4B: 'Utente B4B',
    admUtenteB4BDesc: 'Username per il database B4B',
    admUtenteDbDinamico: 'Utente DB Dinamico',
    admUtenteDbDinamicoDesc: 'Username per il database Dinamico',
    admUtenteJavaWsDinamico: 'Utente Java WS Dinamico',
    admUtenteJavaWsDinamicoDesc: 'Username per REST Java Dinamico',
    admUtenteWS: 'Utente WS',
    admUtenteWSDesc: "Username per l'autenticazione ai web services",
    admVisualizzaBottoneReport: 'Visualizza bottone report',
    admVisualizzaBottoneReportDesc: 'Mostra il bottone per i report',
    cerca: 'Cerca...',
    conversazioni: 'Conversazioni',
    cpCompilatoDaNora: 'compilato da Nora',
    data: 'Data',
    errAeroportoIATAnotFound: 'IATA Aeroporto non trovato',
    errAttachmentsInEmail: 'Allegati interni in email',
    errCanceled: 'Cancellate da operatore',
    errCarnetError: 'Errore ricerca carnet',
    errDefault: 'Altro',
    errDepartureCarJsonNotFound: 'Dati partenza/arrivo auto non trovati',
    errDestinationHotelNotFound: 'Destinazione hotel non trovata',
    errDuplicazioneProfiloTrovato: 'Duplicazione profilo trovato',
    errEmailMancanteProfiloViaggiatore: 'Email mancante profilo viaggiatore',
    errErroreCreazionePreventivi: 'Errore creazione preventivi',
    errErroreCreazioneServizi: 'Errore creazione servizi',
    errErroreCreazioneTrasferta: 'Errore creazione trasferta',
    errErroreElaborazioneServizi: 'Errore elaborazione servizi',
    errErroreRicercaDinamico: 'Errore ricerca dinamico',
    errErroreRicercaDinamicoVuoto: 'Nessun risultato ricerca servizi',
    errErrorSavingAttachments: 'Errore salvataggio allegati',
    errGenericError: 'Errore generico',
    errLoopError: 'Errore di loop',
    errMaxAIMessagesReachedInGC: 'Contenuto generico (non trasferta)',
    errMoreThanOneTransfer: 'Più di una trasferta trovata',
    errNessunProfiloTrovato: 'Nessun profilo trovato',
    errNessunProfiloTrovatoTA: 'TA mancante sul viaggiatore',
    errNoAirportFound: 'Aeroporto non trovato',
    errNoFinalizzazioneCorretta: 'Finalizzazione non avvenuta',
    errNoKeyServizioGenerato: 'Chiave servizio mancante',
    errNoNoraTransfer: 'Trasferta non creata da Nora',
    errNonTrovatoRiferimentoServizioSuMidOffice: 'Riferimento servizio non trovato su mid office',
    errNoProfileInfoTrovato: 'Profilo non trovato',
    errNoTransferFound: 'Nessuna trasferta trovata',
    errOutOfOffice: 'Out of office',
    errPasseggeriMultipli: 'Passeggeri multipli',
    errProfiloMittenteNonTA: 'Profilo mittente non Travel Arranger',
    errProfiloNoPresenteSuGDS: 'Profilo non presente su GDS',
    errRichiestaAggiornamentoTrasferta: 'Ric. aggiornamento trasferta',
    errRichiestaModificaOCancellazioneTrasferta: 'Ric. mod./canc. trasferta',
    errSollecito: 'Sollecito',
    errTooManyDaysHotel: 'Soggiorno hotel troppo lungo',
    errTooManyMessages: 'Limite messaggi raggiunto',
    errTooMuchServiceBoth: 'Troppi servizi treno e aereo',
    errTooMuchServicePlane: 'Troppi servizi aereo',
    errTooMuchServiceTrain: 'Troppi servizi treno',
    gfDi: 'di',
    gfNumerico: 'numerico',
    gfReturnLeg: 'Ritorno',
    gfSeleziona: 'Seleziona',
    gfSelezionaData: 'Seleziona data',
    gfServizioCopertoDaCarnet: 'Servizio coperto da CARNET',
    gfTransferDepartureDate: 'Data di partenza',
    gfTransferDeparturePlace: 'Luogo di partenza',
    gfTransferDestinationPlace: 'Luogo di destinazione',
    gfTransferNumPax: 'Numero passeggeri',
    gfTransferReturnDate: 'Data di ritorno',
    mcApri: 'apri',
    mcAutotestAggiornato: 'Autotest aggiornato',
    mcConversazioneIniziataIl: 'Conversazione iniziata il',
    mcCopiatoNegliAppunti: 'Copiato negli appunti',
    mcCredenzialiErrate: 'Credenziali errate',
    mcDebug: 'Debug',
    mcErroreImprevisto: 'Spiacenti, si è verificato un errore imprevisto.',
    mcFilenameLabel: 'filename',
    mcMe: 'Io',
    mcNameLabel: 'name',
    mcOggetto: 'Oggetto',
    mcOoops: 'Ooops!',
    mcPayloadCopiato: 'Il payload copiato negli appunti',
    mcRichiestaViaggio: 'Richiesta viaggio',
    mcScriviMessaggio: 'Scrivi un messaggio...',
    mcTestNonTrovato: 'Test non trovato',
    mxErroreImportazioneViaggiatori: "Errore durante l'importazione dei viaggiatori",
    mxGestisciNoraAI: 'Gestisci Nora AI',
    mxTitoloPanelOperations: 'Panel Operations',
    mxTrovati: 'Trovati',
    mxViaggiatori: 'viaggiatori',
    pfCanale: 'canale',
    pfCosto: 'Costo',
    pfDatiCacheProcessOverview:
      'Dati da tabella cache processOverviewHourly (allineata alle conversazioni nel periodo).',
    pfFinalState: 'Stato finale',
    pfInitialState: 'Stato iniziale',
    pfMediaBin: 'Media/bin',
    pfOrdinateDecrescente: 'ordinate decrescente',
    pfProcessi: 'Processi',
    pfScatterCacheHint:
      'Punti da tabella cache processOverviewHourly (campioni per ora). Clicca per aprire il processo.',
    pfScatterCacheHintLong:
      'Punti da tabella cache processOverviewHourly (campioni per ora, max 5000 punti totali). Clicca per aprire il processo.',
    pfStato: 'Stato',
    pfStep: 'step',
    pfTokenRichieste: 'Token/Richieste',
    pfTotaleCache: 'Totale (cache)',
    pfUnitSelezionate: 'unit selezionate',
    stCosto: 'Costo',
    tdAereo: 'Aereo',
    tdAeroportoArrivo: 'Aeroporto arrivo',
    tdAeroportoArrivoNonValido: 'Aeroporto di arrivo non valido',
    tdAeroportoPartenza: 'Aeroporto partenza',
    tdAeroportoPartenzaNonValido: 'Aeroporto di partenza non valido',
    tdAnteprimaRisultatiDinamico: 'Anteprima risultati dinamico',
    tdArrivo: 'Arrivo',
    tdCamera: 'Camera',
    tdCerca: 'Cerca',
    tdCitta: 'Città',
    tdCittaNonValida: 'Città non valida',
    tdClasse: 'Classe',
    tdCompagnia: 'Compagnia',
    tdCoordinate: 'Coordinate',
    tdDataArrivo: 'Data Arrivo',
    tdDataCancellazione: 'Data Cancellazione',
    tdDataCheckIn: 'Data Check In',
    tdDataCheckOut: 'Data Check Out',
    tdDataPartenza: 'Data Partenza',
    tdDistanza: 'Distanza',
    tdDurata: 'Durata',
    tdEchoToken: 'Echo Token',
    tdFormatoDataOraNonValido: 'Formato date/ora non valido',
    tdFormatoDateNonValido: 'Formato date non valido',
    tdHotel: 'Hotel',
    tdIdCommunity: 'Id Community',
    tdIndirizzo: 'Indirizzo',
    tdKgBagaglio: 'Kg Bagaglio',
    tdLat: 'Lat',
    tdLatitudine: 'Latitudine',
    tdLng: 'Lng',
    tdLongitudine: 'Longitudine',
    tdMetri: 'metri',
    tdMiniRules: 'Mini Rules',
    tdOraArrivo: 'Ora Arrivo',
    tdOraPartenza: 'Ora Partenza',
    tdPartenza: 'Partenza',
    tdPreferenzaPosto: 'Preferenza posto',
    tdPrezzo: 'Prezzo',
    tdPrezzoAncillary: 'Prezzo + Ancillary',
    tdRisultati: 'risultati',
    tdServiziAggiuntivi: 'Servizi aggiuntivi',
    tdSottotitoloAnteprima: 'Visualizza i risultati grezzi restituiti dal motore di ricerca',
    tdStazioneArrivo: 'Stazione Arrivo',
    tdStazioneArrivoNonValida: 'Stazione di arrivo non valida',
    tdStazionePartenza: 'Stazione Partenza',
    tdStazionePartenzaNonValida: 'Stazione di partenza non valida',
    tdTariffa: 'Tariffa',
    tdTipo: 'Tipo',
    tdTipoRicerca: 'Tipo Ricerca',
    tdTratta: 'Tratta',
    tdTrattamento: 'Trattamento',
    tdTrattaN: 'Tratta N°',
    tdTreno: 'Treno',
    tdTypeRoom: 'TypeRoom',
    abilitaMessaggiFirmati: 'Abilita messaggi firmati con nome Nora',
    abilitaMessaggiFirmatiDescrizione:
      "Se attivato, i messaggi inviati all'utente saranno firmati con il nome 'Nora' per garantire un'esperienza più personalizzata.",
    abilitaMessaggioFinale: 'Abilita invio di un messaggio finale al richiedente della trasferta',
    abilitaMessaggioFinaleDescrizione:
      'Se attivato, viene inviato un messaggio informativo al richiedente della trasferta al termine della procedura. (testuale o con il link in caso di preventivi generati automaticamente)',
    abilitato: 'Abilitato',
    abilitazioneStepAvanzamento: 'Abilitazione step di avanzamento:',
    active: 'Attivo',
    aggiungiFarreTreno: 'Aggiungi tariffa',
    aggiungiInformazioniMeteo: 'Aggiungi le informazioni meteo al messaggio',
    aggiungiInformazioniMeteoDescrizione:
      'Se attivato, il messaggio includerà le previsioni meteo relative al periodo della trasferta, fornendo dettagli utili per la pianificazione.',
    aggiungiServizio: 'Aggiungi Servizio',
    aereo: 'Aereo',
    aic: 'AIC',
    adminCoefficients: 'Admin Coefficienti',
    annulla: 'Annulla',
    attachmentsInEmail: "Allegati nell'email",
    auto: 'Auto',
    autoTest: 'Test Automatico',
    azioni: 'Azioni',
    bestBuy: 'Best buy',
    cancellata: 'Cancellata',
    caricamento: 'Caricamento...',
    chat: 'Chat',
    chooseClientGroupClient: 'Cliente',
    chooseClientGroupDefault: 'Seleziona una voce...',
    chooseClientGroupGroup: 'Gruppo',
    clickToPreviewMessage:
      'Clicca "Anteprima messaggio" per visualizzare il corpo in una nuova finestra',
    codice: 'Codice',
    codiceCliente: 'Codice Cliente',
    codiceGruppo: 'Codice Gruppo',
    communityPanel: 'Pannello Community',
    communityPresetsList: 'Lista Community Preset',
    compagniaTreno: 'Compagnia Treno',
    compilareCampiObbligatori: 'Compilare tutti i campi obbligatori',
    conferma: 'Conferma',
    confermaInvio: 'Conferma Invio',
    conto: 'Conto',
    controllaPreventivi: 'Controlla preventivi',
    controllaPreventiviDescrizione:
      "Se attivo, i preventivi non vengono inviati al viaggiatore, ma vengono creati nello stato 'in lavorazione' per essere visionati",
    conversations: 'Conversazioni',
    createNew: 'Crea Nuovo',
    creationDate: 'Data creazione',
    creato: 'Creato',
    creazionePreventivo: 'Creazione preventivo',
    creazioneTrasfertaServizi: 'Creazione trasferta e servizi',
    currentIsola: 'Isola corrente',
    datiTrasferta: 'Dati trasferta',
    datiViaggiatore: 'Dati Viaggiatore',
    defaultPreset: 'Default Preset',
    deleteDefaultPresetError: 'Impossibile eliminare il preset di default',
    deleteServiceHeader: 'Cancellazione Servizio',
    deleteServiceLabel: 'Vuoi cancellare questo servizio?',
    deleteSuccess: 'Eliminazione effettuata',
    descrizione: 'Descrizione',
    distance: 'Distanza',
    duplicazioneProfiloTrovato: 'Duplicazione profilo viaggiatore, trovata omonimia',
    duration: 'Durata',
    dynamicTest: 'Test Dinamico',
    elaborazioneMessaggioInCorso: 'Elaborazione messaggio in corso',
    elaborazioneMessaggioInCorsoDetails:
      'Elaborazione messaggio in corso... attendere il completamento.',
    error: 'Errore',
    errore: 'Errore',
    escludiNora: 'Escludi Nora',
    formale: 'Formale',
    formaleDefault: 'formale (default)',
    gestireDaMidoffice: 'Gestire da Midoffice',
    gestireManualmente: 'Gestire manualmente da Midoffice',
    gestisciNoraAI: 'Gestisci Nora AI',
    gruppo: 'Gruppo',
    hotel: 'Hotel',
    hotelAutomatico: 'Hotel automatico',
    hotelAutomaticoDescrizione:
      "Nel caso in cui la trasferta duri più giorni, viene aggiunto in automatico l'hotel.",
    id: 'Id',
    identificativoAnno: 'Identificativo Anno',
    identificativoPratica: 'Identificativo Pratica',
    identificativoRichiesta: 'Identificativo Richiesta',
    ignorata: 'Ignorata',
    impostazionePreventiviGenerati: 'Impostazione preventivi generati',
    impostazioni: 'Impostazioni',
    impostazioniSistema: 'Impostazioni Sistema',
    salvataggioEffettuato: 'Salvataggio effettuato',
    stateDiffDescrizione:
      'Se attivo, le nuove conversazioni utilizzeranno il formato State Diff per lo storico dei processi. Le conversazioni esistenti non vengono modificate.',
    nessunRecordSistema: 'Nessun record system trovato nel database.',
    inAttesaDiConferma: 'In attesa di conferma',
    inEsecuzione: 'In esecuzione',
    inactive: 'Disattivo',
    indicateFormalityLevel: 'Indicare livello di formalità',
    indietro: 'Indietro',
    informale: 'Informale',
    inserireDatiViaggiatore: 'Inserire i dati del viaggiatore',
    logicaCameraNonInPenale: 'Logica camera non in penale',
    logicaCameraNonInPenaleDescrizione1:
      "Se l'hotel è soggetto a penale, verrà cercata la disponibilità della prima camera non soggetta a penale dello stesso hotel.",
    logicaCameraNonInPenaleDescrizione2:
      "Nel caso in cui questa non sia disponibile, verrà selezionata la camera 'best buy'.",
    login: 'Login',
    logout: 'Logout',
    mastro: 'Mastro',
    messaggioLink: "All'interno del messaggio dove compare:",
    messaggioLinkPreventivi: "- '#link': verrà inserito il link per visualizzare i preventivi",
    messaggioMeteo:
      '- \'#meteo\': verranno inserite le informazioni sul meteo (se richiesta viaggio è entro 5 gg dalla partenza). Per far visualizzare la frase è necessario abilitare il flag "Inclusione informazioni meteo"',
    messaggioPreimpostatoUtente: 'Messaggio preimpostato per utente',
    messaggioPreimpostatoUtenteDescrizione:
      'Se selezionato verrà notificato il viaggiatore che la sua richiesta è presa in carico da un operatore reale.',
    messaggioPreventivi: 'Messaggio per preventivi:',
    messaggioReindirizzamentoOperatore: 'Messaggio per reindirizzamento operatore:',
    messaggioReindirizzamentoOperatoreDescrizione:
      "Messaggio preimpostato da inviare all'utente in caso di reindirizzamento all'operatore",
    modificaViaggiatore: 'Modifica viaggiatore',
    moltoFormale: 'Molto formale',
    nProposte: 'N. Proposte',
    nessunProfiloTrovato: 'Profilo non trovato',
    nessunProfiloTrovatoTA: 'Legame viaggiatore e TA non trovato',
    profiloMittenteNonTA: 'Profilo mittente non Travel Arranger',
    nessunServizioInserito: 'Nessun servizio inserito',
    nessunServizioTrenoInserito: 'Nessun servizio treno inserito',
    nessunServizioHotelInserito: 'Nessun servizio hotel inserito',
    nessunServizioAereoInserito: 'Nessun servizio aereo inserito',
    nessunServizioAutoInserito: 'Nessun servizio auto inserito',
    servizioEmptyHint: 'Aggiungilo solo se richiesto in conversazione',
    no: 'No',
    noConversationsFound: 'Nessuna conversazione trovata',
    noPresetFound: 'Nessun preset trovato',
    noProfileInfoTrovato: 'Profilo viaggiatore non trovato',
    noraEsclusa: 'Nora Esclusa',
    operations: 'Operazioni',
    operatoreCreazionePratica: 'Operatore creazione pratica',
    outOfOffice: 'Out of office',
    sollecito: 'Sollecito',
    maxAIMessagesReachedInGC: 'Contenuto generico (non trasferta)',
    panelOperations: 'Pannello operazioni',
    performanceMonitor: 'Performance Monitor',
    passeggeriMultipli: 'Passeggeri multipli identificati',
    pocoFormale: 'poco formale',
    prendiInCarico: 'Prendi in carico',
    presetAbilitato: 'Preset abilitato',
    previewMessage: 'Anteprima messaggio',
    price: 'Prezzo',
    processes: 'Processi',
    prontoARipartire: 'In esecuzione',
    pubblicaLoStesso: 'Pubblica lo stesso',
    pubblicaLoStessoDescrizione:
      'Se non vengono trovati risultati in uno dei servizi richiesti, i preventivi vengono comunque pubblicati',
    raccoltaInformazioni: 'Raccolta informazioni',
    ragioneSociale: 'Ragione Sociale',
    requester: 'Richiedente',
    ricercaCliente: 'Ricerca cliente',
    ricercaGruppo: 'Ricerca gruppo',
    ricercaPer: 'Ricerca per',
    richiediMezzoTrasporto: 'Richiedi il mezzo di trasporto se non specificato',
    richiediMezzoTrasportoDescrizione:
      "Se attivato, verrà chiesto all'utente se desidera un servizio aereo o ferroviario per raggiungere la destinazione nel caso in cui non sia già stato indicato.",
    richiestaModificaOCancellazioneTrasferta: 'Richiesta modifica o cancellazione trasferta',
    richiestaAggiornamentoTrasferta: 'Richiesta aggiornamento informazioni trasferta',
    salva: 'Salva',
    selectEmail: 'Seleziona Email',
    selectEmailRedirect: 'Seleziona Email Redirect To Operator',
    selectEnvironment: 'Seleziona Environment',
    selectEnvironmentPlaceholder: 'Seleziona Environment',
    selectFormalityLevel: 'Seleziona livello di formalità',
    selectPID: 'Seleziona PID',
    selectUnit: 'Seleziona unit da eseguire',
    selectUnitToExecute: 'Seleziona unit da eseguire',
    selectedDate: 'Data selezionata',
    seleziona: 'Seleziona',
    selezionaPrioritaServizio: 'Seleziona la priorità del servizio',
    selezionaPrioritaTariffa: 'Seleziona la priorità della tariffa treno',
    selezionaRicerca: 'Seleziona ricerca',
    tariffeRimborsabili: 'Tariffe Rimborsabili',
    tariffeNonRimborsabili: 'Tariffe Non Rimborsabili',
    selezionato: 'Selezionato',
    serviziAereo: 'Servizi Aereo',
    serviziAuto: 'Servizi Auto',
    serviziHotel: 'Servizi Hotel',
    serviziTreno: 'Servizi Treno',
    servizio: 'Servizio',
    societyList: 'Elenco Società',
    soloCamereNonInPenale: 'Solo camere non in penale',
    soloCamereNonInPenaleDescrizione:
      "Nel caso in cui non si trovino camere non soggette a penale in un determinato hotel, passare all'hotel successivo e ripetere fino a 10 tentativi.",
    sottoConto: 'Sotto Conto',
    state: 'Stato',
    stepNascostoB4B:
      "Questo step è selezionato ma l'integrazione B4B è disattivata. Seleziona un altro step o riattiva il B4B.",
    statistics: 'Statistiche',
    success: 'Success',
    terminato: 'Terminato',
    time: 'Orario',
    tipo: 'Tipo',
    tipologiaTariffa: 'Tipologia Tariffa',
    titolo: 'Titolo',
    titoloPreset: 'Titolo Preset',
    tolleranzaGiorniPenale: 'Tolleranza Giorni Penale',
    tonoEmail: 'Tono email:',
    tornaIndietro: 'Torna Indietro',
    trasfertaCreata: 'Trasferta creata',
    travellersList: 'Elenco Viaggiatori',
    treno: 'Treno',
    usaPresetDefault: 'Usa preset come default',
    userList: 'Elenco Utenti',
    users: 'Utenti',
    verificaConfermaDatiIA: "Verifica e conferma i dati generati dall'IA",
    verificaConfermaDatiIADescrizione:
      "Dopo la raccolta dei dati, l'operatore dovrà controllare e confermare le informazioni inserite dall'intelligenza artificiale nella sezione 'Form Operatore'",
    vuoiConfermareDati: 'Vuoi confermare i dati?',
    vuoiPrendereInCarico: 'Vuoi prendere in carico la conversazione?',
    gfAttendiCompletamentoTrasferta: 'Attendi il completamento per modificare la trasferta',
    gfAvviata: 'Avviata',
    gfCampi: 'campi',
    gfCampiDaCompilare: 'da compilare',
    gfCampiDaRivedere: 'da rivedere',
    gfCampiObbligatoriDaCompilare: 'obbligatori da compilare',
    gfCampiObbligatoriMancanti: 'CAMPI OBBLIGATORI MANCANTI',
    gfCampiPersonalizzati: 'Campi personalizzati',
    gfCampo: 'campo',
    gfCampoObbligatorio: 'Campo obbligatorio',
    gfCampoObbligatorioMancante: 'CAMPO OBBLIGATORIO MANCANTE',
    gfCaricamentoProfilo: 'Caricamento profilo',
    gfCaricamentoProfiloDettaglio: 'Attendi mentre recupero i dati del viaggiatore selezionato…',
    gfCerca: 'Cerca',
    gfChiudiAnteprima: 'Chiudi anteprima',
    gfAllegati: 'Allegati',
    gfAllegatoFile: 'File',
    gfAllegatiNelCorpoEmail:
      'Immagini nel corpo email (di solito visibili anche inline nel messaggio sopra)',
    gfInCorpoEmail: 'corpo email',
    gfChatComposerPlaceholder: 'Scrivi un messaggio… Invio per inviare, Maiusc+Invio per a capo',
    gfChatSend: 'Invia messaggio',
    gfAudio: 'Audio',
    gfComprimi: 'Comprimi',
    gfContieneErrori: 'contiene errori',
    gfContieneErroriTitle: 'Contiene errori',
    gfConversazioneNonTrovata: 'Conversazione non trovata',
    gfDaRivedere: 'Da rivedere',
    gfEspandi: 'Espandi',
    gfImmagine: 'Immagine',
    gfLetto: 'letto',
    gfConversazione: 'Conversazione',
    gfConversazioneConNora: 'Conversazione con Nora',
    gfConversazionePrecedente: 'Conversazione precedente',
    gfConversazioneSuccessiva: 'Conversazione successiva',
    gfConv: 'Conv.',
    gfCreaTest: 'Crea test',
    gfDa: 'da',
    gfDeleteServiceLabelIrreversible:
      "Vuoi cancellare questo servizio? L'operazione non può essere annullata.",
    gfEliminaServizio: 'Elimina servizio',
    gfElaborazioneInCorso: 'Elaborazione in corso',
    gfErroreAggiornamentoState: 'Errore aggiornamento state',
    gfErroreCaricamentoViaggiatore: 'Errore durante il caricamento del viaggiatore',
    gfErroreConfermaForm: 'Errore conferma form',
    gfErroreCreazioneTest: 'Si è verificato un errore durante la creazione del test',
    gfErroreInvioSegnalazione: "Errore durante l'invio della segnalazione",
    gfErroreRicercaViaggiatore: 'Errore durante la ricerca del viaggiatore',
    gfEsclusioneNora: 'Esclusione nora',
    gfEscludiNoraSub: 'I prossimi messaggi dovranno essere gestiti solamente da middle office.',
    gfFiltrato: 'Filtrato',
    gfFormInviatoSuccesso: 'Form inviato con successo',
    gfHaPrecompilato: 'ha precompilato',
    gfHintRicercaViaggiatore: 'Inserisci nome e cognome e/o email per effettuare la ricerca',
    gfInvia: 'Invia',
    gfInviaSegnalazione: 'Invia segnalazione',
    gfModificaTrasferta: 'Modifica trasferta',
    gfMostraTutteSezioni: 'Mostra tutte le sezioni',
    gfMostraSoloSezioniDaRivedere: 'Mostra solo sezioni con campi da rivedere',
    gfNessunViaggiatoreTrovato: 'Nessun viaggiatore trovato',
    gfNessunViaggiatoreTrovatoHint: 'Prova a modificare nome, cognome o email e ripeti la ricerca.',
    gfNoteSegnalazione: 'Note segnalazione',
    gfEmailOperatoreSegnalazione: 'La tua email',
    gfEmailOperatoreSegnalazioneHint:
      'Useremo questo indirizzo per risponderti. Lo ricorderemo per le prossime segnalazioni.',
    gfEmailOperatoreSegnalazioneNonValida: 'Inserisci un indirizzo email valido',
    gfNuovaTrasferta: 'Nuova trasferta',
    gfNuovaConversazione: 'Nuova conversazione',
    gfOperazioneSuccesso: 'Operazione avvenuta con successo',
    gfPerCreareTrasferta: 'per creare la trasferta',
    gfPerModificareConversazione: 'Per modificare la conversazione prendila in carico',
    gfProntaDaCreare: 'Pronta da creare',
    gfProcessi: 'Processi',
    gfPulisciCampi: 'Pulisci campi',
    gfRicercaInCorso: 'Ricerca in corso',
    gfRicercaInCorsoDettaglio: 'Sto cercando i profili corrispondenti ai criteri inseriti…',
    gfRicercaPuntini: 'Ricerca…',
    gfRicercaViaggiatore: 'RICERCA VIAGGIATORE',
    gfRimuovi: 'Rimuovi',
    gfRimuoviServizio: 'Rimuovi servizio',
    gfRisultatoTrovato: 'risultato trovato',
    gfRisultatiTrovati: 'risultati trovati',
    gfRisolviErroriIn: 'Risolvi gli errori in',
    gfSalvaBozza: 'Salva bozza',
    gfSelezionaViaggiatore: 'Seleziona un viaggiatore',
    gfSegnalazioneInviata: 'Segnalazione inviata',
    gfSegnalazioneInviataSuccesso: 'La segnalazione è stata inviata con successo',
    gfSezioniForm: 'Sezioni del form',
    gfServizio: 'servizio',
    gfServizi: 'servizi',
    gfVuoto: 'Vuoto',
    gfSolaLettura: 'sola lettura',
    gfSoloDaRivedere: 'Solo da rivedere',
    gfStateAggiornatoSuccesso: 'State aggiornato con successo',
    gfTestCreato: 'Test creato',
    gfTestCreatoSuccesso: 'Il test è stato creato con successo',
    gfTrasferta: 'Trasferta',
    gfTuttiCampiObbligatoriCompilati: 'Tutti i campi obbligatori sono compilati.',
    gfVaiAProcessi: 'Vai a processi',
    gfViaggiatore: 'Viaggiatore',
    gfVuoiEscludereNora: 'Vuoi escludere Nora dalla conversazione?',
    // Login
    loginTitle: 'Accedi al Sistema',
    loginButton: 'Accedi',
    poweredBy: 'Powered by',
    // Admin lists
    societyListTitle: 'Lista Società',
    societyCode: 'Codice Società',
    societyNameCol: 'Nome società',
    urlAtlante: 'Url Atlante',
    noSocietyFound: 'Nessuna società trovata',
    deleteSocietyHeader: 'Cancellazione Società',
    deleteSocietyMessage: 'Vuoi cancellare questa società?',
    userListTitle: 'Lista Utenti',
    noUserFound: 'Nessun utente trovato',
    deleteUserHeader: 'Cancellazione Utente',
    deleteUserMessage: 'Vuoi cancellare questo utente?',
    travellersListTitle: 'Lista Viaggiatori',
    noTravellerFound: 'Nessun viaggiatore trovato',
    deleteTravellerHeader: 'Cancellazione Viaggiatore',
    deleteTravellerMessage: 'Vuoi cancellare questo viaggiatore?',
    importTravellers: 'Importa viaggiatori',
    phone: 'Telefono',
    client: 'Cliente',
    // Process
    processListTitle: 'Lista Processi',
    goToForm: 'Vai a form',
    pricing: 'Pricing',
    noProcessFound: 'Nessun processo trovato',
    processId: 'Id Processo',
    openStep: 'Apri step',
    conversation: 'Conversazione',
    messages: 'messaggi',
    readOnly: 'Sola lettura',
    continueExecution: 'Prosegui esecuzione',
    processErrors: 'Errori Processi',
    processStats: 'Statistiche Processo',
    processComparison: 'Confronto Processo',
    // Filters
    filters: 'Filtri',
    date: 'Data',
    island: 'Isola',
    allIslands: 'Tutte le isole',
    allStates: 'Tutti gli stati',
    search: 'Ricerca',
    searchPlaceholder: 'Cerca per nome, email, AIC...',
    searchConversations: 'Ricerca globale conversazioni',
    clearSearch: 'Pulisci ricerca',
    resetFilters: 'Reset filtri',
    removeAllFilters: 'Rimuovi tutti i filtri',
    activeFilterOne: 'attivo',
    activeFilterMany: 'attivi',
    // Conversation actions
    viewDetail: 'Vedi dettaglio conversazione',
    open: 'Apri',
    warningConversationPending: 'Attenzione: conversazione in attesa',
    conversationPending: 'Conversazione in attesa',
    tripsInProgress: 'Lista trasferte in lavorazione',
    // Theme
    switchToLight: 'Passa al tema chiaro',
    switchToDark: 'Passa al tema scuro',
    // Menu
    dashboardPricing: 'Dashboard Pricing',
    prompts: 'Prompts',
    home: 'Home',
    // ActiveFilterChips
    conversationSingular: 'conversazione',
    conversationPlural: 'conversazioni',
    removeFilterDate: 'Rimuovi filtro data',
    removeFilterIsland: 'Rimuovi filtro isola',
    removeFilterState: 'Rimuovi filtro stato',
    removeSearch: 'Rimuovi ricerca',
    // Community alerts
    linkMissing: 'Link mancante',
    linkMissingDetail: "Nel messaggio per preventivi manca '#link'",
    weatherInfoMissing: 'Info meteo mancanti',
    weatherInfoMissingDetail: "Nel messaggio per preventivi manca '#meteo'",
    titleMissing: 'Titolo mancante',
    selectGroupOrClient:
      'Selezionare un gruppo o un cliente oppure selezionare come default preset',
    groupNotFound: 'Gruppo non trovato',
    // Chat
    testChat: 'Chat di test',
    testChatSubtitle: "Esegui un'unit specifica simulando una conversazione completa",
    testParameters: 'Parametri test',
    testConversation: 'Conversazione di test',
    warning: '⚠️',
    yes: 'Sì',
    // Common
    modifica: 'Modifica',
    elimina: 'Elimina',
    chiudi: 'Chiudi',
    dataInizio: 'Data inizio',
    dataFine: 'Data fine',
    giornoPrecedente: 'Giorno precedente',
    giornoSuccessivo: 'Giorno successivo',
    dataDa: 'Data da',
    dataA: 'Data a',
    periodo: 'Periodo',
    tutti: 'Tutti',
    media: 'Media',
    errori: 'Errori',
    nessunDatoDisponibile: 'Nessun dato disponibile',
    totale: 'Totale',
    processo: 'Processo',
    rimuovi: 'Rimuovi',
    secondi: 'secondi',
    minuti: 'minuti',
    eWord: 'e',
    nonTerminato: 'Non terminato',
    // Gigi FilterBar
    filtraPerDataIsolaStato: 'Filtra per data, isola, stato o ricerca libera',
    // Process/Conversations
    listaConversazioni: 'Lista Conversazioni',
    gestioneConversazioniPerData: 'Gestione conversazioni per data',
    filtraPerData: 'Filtra per data',
    viaggiatore: 'Viaggiatore',
    conversazioneChiusa: 'Conversazione chiusa',
    erroreChiusuraConversazione: 'Errore chiusura conversazione',
    // Process/Editor
    processStepsVisualizer: 'Process Steps Visualizer',
    differenzeStati: 'Differenze Stati',
    statoStep: 'Stato step',
    selezionaTipoOperazione: 'Seleziona il tipo di operazione',
    workflow: 'Workflow',
    riesecuzioneUnit: 'Riesecuzione unit',
    selezionaRieseguiStep: 'Seleziona Riesegui su uno step',
    finalState: 'Final State',
    rieseguiUnaUnit: 'Riesegui una unit',
    esecuzioneInCorso: 'Esecuzione in corso…',
    rieseguiUnit: 'Riesegui unit',
    visualizzaErrore: 'Visualizza errore',
    errorePrefix: 'Errore: ',
    logLabel: 'Logs',
    initialState: 'Initial State',
    initialStack: 'Initial Stack',
    finalStack: 'Final Stack',
    inCorso: 'in corso…',
    // Process/ErrorStats
    statisticheErroriPerIntervallo: 'Statistiche errori per intervallo date',
    intervalloDate: 'Intervallo date',
    processiInErrore: 'Processi in errore',
    unitInErrore: 'Unit in errore',
    nonCiSonoErrori: 'Non ci sono errori',
    dettaglioProcessiErrore: 'Dettaglio processi in errore',
    // Process/Performance
    panoramica: 'Panoramica',
    performanceUnitTab: 'Performance Unit',
    trendAnalisi: 'Trend & Analisi',
    statisticheErrori: 'Statistiche errori',
    selezionaRange: 'Seleziona un range oppure usa i preset rapidi',
    cacheAggiornata: 'Cache aggiornata',
    erroreBackfillCache: 'Errore backfill cache',
    erroreSconosciuto: 'errore sconosciuto',
    nessunDatoCache:
      'Nessun dato in cache processOverviewHourly per questo intervallo. Esegui «Backfill cache» con lo stesso range (o attendi il cron ogni 10 minuti per le ultime ore).',
    backfillCache: 'Backfill cache',
    aggiornamentoCache: 'Aggiornamento cache...',
    backfillCacheStatistiche: 'Backfill cache statistiche',
    precomputaDescrizione:
      'Precomputa unitStatsHourly e processOverviewHourly (cache performance e panoramica).',
    preset: 'Preset',
    oreCustom: 'Ore custom',
    rangePagina: 'Range pagina',
    oreDaRicalcolare: 'Ore da ricalcolare',
    eseguiBackfill: 'Esegui backfill',
    selezioneGrafico: 'Selezione grafico: usa il bottone "Grafico" nella tabella.',
    caricamentoDatiCache: 'Caricamento dati cache…',
    cache: 'Cache',
    unit: 'unit',
    // Process/Performance DrillDown
    dettaglio: 'Dettaglio:',
    mostraTutti: 'Mostra tutti',
    soloLenti: 'Solo lenti',
    nessunaEsecuzioneTrovata: 'Nessuna esecuzione trovata',
    tempo: 'Tempo',
    inizio: 'Inizio',
    conv: 'Conv.',
    // Process/Performance UnitStatsTable
    statistichePerUnit: 'Statistiche per Unit',
    unitNelPeriodo: 'unit nel periodo',
    legenda: 'Legenda',
    cercaUnit: 'Cerca unit...',
    evidenziazioneRighe: 'Evidenziazione righe',
    tutte: 'Tutte',
    soloEvidenziate: 'Solo evidenziate',
    soloNonEvidenziate: 'Solo non evidenziate',
    aggiungiAlGrafico: 'Aggiungi al grafico',
    drillDown: 'Drill down',
    legendaColoriRegole: 'Legenda colori e regole',
    nelPeriodo: 'Nel periodo',
    deltaVsMediaComplessiva: 'Δ vs media complessiva',
    colAzioni: 'Azioni',
    colN: 'N.',
    colErrPerc: 'Err%',
    colP90Media: 'P90÷Media',
    colDeltaMedia: 'Δ Media',
    colDeltaP50: 'Δ P50',
    colDeltaP90: 'Δ P90',
    colDeltaP95: 'Δ P95',
    colDeltaP99: 'Δ P99',
    // Process/Pricing
    costoLlmProcessi: 'Costo LLM per i processi della conversazione',
    filtraProvider: 'Filtra provider',
    selezionaProviderVisualizzare: 'Seleziona i provider da visualizzare',
    dettaglioCostiUnit: 'Dettaglio costi per unit',
    ripartizioneCosti: 'Ripartizione costi',
    perProvider: 'Per provider',
    nessunCostoVisualizzare: 'Nessun costo da visualizzare per i provider selezionati.',
    // Process/Stats
    statoProcessSteps: 'Stato process steps',
    processStepsInErrore: 'Process Steps in errore',
    riepilogoCosti: 'Riepilogo Costi',
    tempiDiEsecuzione: 'Tempi di esecuzione',
    tempoDiEsecuzione: 'Tempo di esecuzione:',
    tempiUnit: 'Tempi unit',
    min: 'Min',
    max: 'Max',
    sommaUnit: 'Somma unit:',
    ordineEsecuzione: 'Ordine esecuzione',
    durata: 'Durata',
    // Prompts
    prompt: 'Prompt',
    campo: 'Campo',
    spiegazione: 'Spiegazione',
    nessunPromptInserito: 'Nessun prompt inserito',
    // Statistics
    selezionaPeriodoAnalisi: 'Seleziona il periodo di analisi o usa i preset rapidi',
    selezionaPeriodoLabel: 'Seleziona periodo:',
    filtraPerIsolaUnitaCliente: 'Filtra per isola, unità operativa o cliente',
    unitaOperativa: 'Unità operativa',
    tutteLeUnitaOp: 'Tutte le unità op.',
    tuttiIClienti: 'Tutti i clienti',
    cercaCliente: 'Cerca cliente...',
    reset: 'Reset',
    totaleFatturatiNelPeriodo: 'Totale fatturati nel periodo',
    nConversazioni: 'n° conversazioni:',
    costoAConversazione: 'Costo a conversazione:',
    gestiteDaNora: 'Gestite da Nora',
    escluseConversazioniInoltrate: "* escluse le conversazioni inoltrate all'operatore",
    nessunaConversazioneNelPeriodo: 'Nessuna conversazione nel periodo',
    costoTotale: 'Costo totale',
    conversazioniTotali: 'Conversazioni totali',
    elaborate: 'Elaborate:',
    inoltrate: 'Inoltrate:',
    // Test/AutoTest
    datiChatNonDisponibili: 'Dati chat non disponibili',
    importazioneCompletata: 'Importazione completata',
    conversazioniInserite: 'conversazioni inserite',
    saltateGiaPresenti: 'saltate (già presenti)',
    erroreDuranteImportazione: "Errore durante l'importazione o l'esecuzione dei test:",
    autoTestTitle: 'Auto Test',
    autoTestSubtitle: "Test automatici per validare l'estrazione dei dati dalle conversazioni",
    caricamentoInCorso: 'Caricamento in corso...',
    caricaTestConv: 'Carica TESTCONV.json',
    lanciaTuttiITest: 'Lancia tutti i test',
    test: 'Test',
    nessunTestTrovato: 'Nessun test trovato',
    messaggio: 'Messaggio',
    fileAllegati: 'File allegati',
    allegaFile: 'Allega file',
    messaggioBozzaNora: 'Messaggio bozza di Nora: ',
    copia: 'Copia',
    nessunMessaggio: 'Nessun messaggio',
    leggiJson: 'Leggi JSON',
    risultatoElaborazione: 'Risultato Elaborazione',
    step: 'Step',
    combTariffaCompagniaDuplicata: 'Questa combinazione di tariffa e compagnia esiste già',
    duplicato: 'Duplicato',
    apriChiudiMenu: 'Apri o chiudi menu di navigazione',
    chiudiMenu: 'Chiudi menu di navigazione',
    nuovaProposta: 'NUOVA PROPOSTA',
    formatoDataPlaceholder: 'gg/mm/aaaa',
    executionTime: 'Execution Time',
    // Statistics
    stPresetOggi: 'Oggi',
    stPreset7Giorni: '7 giorni',
    stPreset30Giorni: '30 giorni',
    stPresetQuestoMese: 'Questo mese',
    stPreset3Mesi: '3 mesi',
    stPresetAnno: 'Anno',
    stStatusAperta: 'Aperta',
    stStatusTerminata: 'Terminata',
    stStatusGestitaOperatore: 'Gestita da operatore',
    stChartTrasferteCreate: 'Trasferte create',
    stChartInoltrateOperatore: 'Inoltrate ad operatore',
    stChartNoraEsclusa: 'Nora esclusa',
    stChartConversazioniIgnorate: 'Conversazioni ignorate',
    stChartInCaricoOperatore: 'In carico ad un operatore',
    stChartCorrettamenteGestite: 'Correttamente gestite',
    stCardElaborate: 'Conversazioni elaborate',
    stCardConsegnateGestioneManuale: 'Consegnate gestione manuale',
    stCardEscluseErrori: 'Escluse / errori',
    stDettagliElaborate: 'Dettagli % elaborate',
    stDettagliInoltrate: 'Dettagli % inoltrate',
    stDettagliErrori: 'Dettagli % errori',
    stPercTotale: 'Perc. sul totale conv.',
    stPeriodoSelezionato: 'Periodo selezionato:',
    stDashboardEuro: 'Dashboard €',
    stEsportaReport: 'Esporta Report',
    stSegnaFatturato: 'Segna come fatturato',
    stPieGenerale: 'Generale',
    stPieOpenPausa: 'Open o in pausa',
    stPieErroriGestiti: 'Errori gestiti',
    stPieNoraEsclusaOp: 'Nora esclusa da op.',
    stTornaStatistiche: 'Torna a Statistiche',
    stCostoConversazioniTempo: 'Costo conversazioni nel tempo',
    stCostoMedioPeriodo: 'Costo medio nel periodo:',
    // Process Performance
    pfStatoProcessi: 'Stato processi',
    pfProcessiLower: 'processi',
    pfProcessiCreatiPerOra: 'Processi creati per ora',
    pfNessunDatoNelPeriodo: 'Nessun dato nel periodo',
    pfServerCanali: 'Server & canali',
    pfStatoInTempoReale: 'Stato in tempo reale',
    pfOperatori: 'operatori',
    pfTokenMin: 'Token/min',
    pfRichiesteMin: 'Richieste/min',
    pfInCoda: 'In coda:',
    pfNessunDatoServer: 'Nessun dato server disponibile',
    pfConnSuffix: ' conn.',
    pfLegendaRosso: '- **Rosso**: `Err% > 10` (molti errori).',
    pfLegendaGiallo:
      '- **Giallo**: `P90÷Media ≥ ${threshold}` (varianza alta: coda lenta vs media).',
    pfVarianzaP90Media: 'Varianza P90 ÷ Media',
    pfRapportoP90Media: 'Rapporto tra P90 e media aritmetica sul periodo selezionato.',
    pfValoriAltiCoda: 'Valori alti indicano coda lenta rispetto al tempo medio.',
    pfMediaAssolutaColonne: 'Media assoluta e colonne Δ (ms)',
    pfBaselineCalcolata:
      'La baseline è calcolata sugli ultimi 12 mesi di cache oraria, escludendo i bucket del periodo selezionato.',
    pfColonneDeltaMostrano:
      'Le colonne Δ mostrano (periodo − baseline) in ms: positivo = più lento, negativo = più veloce.',
    pfAndamentoNelTempo: 'Andamento nel tempo',
    pfSelezionaUnitTabella: 'Seleziona unit dalla tabella',
    pfSelezionaUnaPiuUnit: 'Seleziona una o più unit dalla tabella per visualizzare il grafico',
    pfNessunDatoNelPeriodoSelezionato: 'Nessun dato nel periodo selezionato',
    pfEsecuzioniSommaUnit: 'Esecuzioni (somma unit):',
    pfMedia: 'media',
    pfAndamentoGiornaliero: 'Andamento giornaliero',
    pfSelezionaUnaPiuUnitGiornaliero: 'Seleziona una o più unit per il grafico giornaliero',
    pfBarreEsecuzioniLinee: 'Barre: esecuzioni · Linee: tempo medio ± deviazione standard',
    pfEsecuzioni: 'Esecuzioni',
    pfTempoMedioMs: 'Tempo medio (ms)',
    pfEsecuzioniSigmaUnit: 'Esecuzioni (Σ unit)',
    pfNessunDatoGiornaliero:
      'Nessun dato giornaliero nel periodo (prova un backfill cache o un range piu ampio)',
    pfTempoMedioPerUnit: 'Tempo medio per unit',
    pfSecondiTop: 'Secondi · top',
    pfDistribuzioneTempiProcessi: 'Distribuzione tempi processi',
    pfOgniPuntoProcesso:
      'Ogni punto rappresenta un processo completato. Clicca per aprire il dettaglio.',
    pfProcessoHash: 'Processo #',
    pfTempo: 'Tempo: ',
    pfNessunProcessoTempo: 'Nessun processo con tempo di esecuzione nel periodo',
    pfVolumeProcessiPanoramica: 'Volume processi · panoramica giornaliera',
    pfTreViste: 'Tre viste sullo stesso intervallo: step per unit, tempi medi, process completati',
    pfGrafici12Prime:
      'Grafici 1 e 2: prime ${max} unit per volume nel periodo su ${total} totali; lo stack include "Altre unit" per il resto.',
    pfStepPerUnitStack: '1 · Step per unit (stack giornaliero)',
    pfColonneImpilate:
      'Colonne impilate: per ogni giorno, quanti step sono stati eseguiti per ciascuna unit in evidenza; la fascia grigia somma le altre unit.',
    pfAltreUnit: 'Altre unit',
    pfTempoMedioEsecuzionePerUnit: '2 · Tempo medio di esecuzione per unit',
    pfLineeMediaGiornaliera:
      'Linee: media giornaliera del tempo di step; barre verticali ± deviazione standard campionaria.',
    pfStepNelGiorno: 'Step nel giorno (tutte le unit):',
    pfProcessCompletatiPerGiorno: '3 · Process completati per giorno',
    pfConteggioProcessEndTime:
      'Conteggio process con endTime nel giorno e state 3 (ok) o 5 (errore). Giorni senza chiusure mostrano 0.',
    pfProcess: 'Process',
    pfProcessCompletati: 'Process completati',
    pfNessunGiornoNelRange: 'Nessun giorno nel range',
    pfMediaRecente: 'Media recente',
    pfBaseline: 'Baseline',
    pfRapporto: 'Rapporto',
    pfErroriRecenti: 'Errori recenti: ',
    pfBaselineInfix: ' (baseline: ',
    pfTuttiSistemiNormali: 'Tutti i sistemi operativi normalmente',
    pfAnomalieRilevate: 'anomalie rilevate',
    pfVistaForm: 'Vista Form',
    pfVistaJson: 'Vista json',
    pfRieseguiUnit: 'Riesegui unit',
    pfConfermaRieseguiUnit:
      'Vuoi rieseguire questa unit con lo stato iniziale dello step selezionato?',
    pfStepPrecedente: 'Step precedente',
    pfStepSuccessivo: 'Step successivo',
    pfRisultatoPrecedente: 'Precedente',
    pfRisultatoSuccessivo: 'Successivo',
    pfCerca: 'Cerca...',
    pfToken: 'Token ',
    tutteEsecuzioni: 'Tutte',
    nessunErroreTrovato: 'Nessun errore trovato nel periodo',
    nomeProcesso: 'Nome',
    ggRoomSingola: 'Singola (1 adulto)',
    ggRoomDoppia: 'Doppia (2 adulti)',
    ggRoomTripla: 'Tripla (3 adulti)',
    ggComposizioneCamere: 'Composizione camere',
    ggAggiungiOpzione: 'Aggiungi opzione',
    ggNessunaPreferenzaCamere: 'Nessuna preferenza camere (verranno usati i default)',
    ggOpzione: 'Opzione',
    ggCamera: 'Camera',
    ggTipoCamera: 'Tipo camera',
    ggCampiPersonalizzati: 'CAMPI PERSONALIZZATI',
    ggErroreRicercaCliente: 'Errore ricerca cliente',
    ggPulisci: 'Pulisci',
    ggNessunaOpzione: 'Nessuna opzione disponibile',
    gfMonthNames: [
      'Gennaio',
      'Febbraio',
      'Marzo',
      'Aprile',
      'Maggio',
      'Giugno',
      'Luglio',
      'Agosto',
      'Settembre',
      'Ottobre',
      'Novembre',
      'Dicembre'
    ],
    gfDayNamesShort: ['Dom', 'Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab'],
    admDisabilitato: 'Disabilitato',
    admSezioneInfoBase: 'Informazioni Base',
    admSezioneImpostazioniAI: 'Impostazioni AI',
    admSezioneIntegrazioneB4B: 'Integrazione B4B',
    admSezioneIntegrazioneAtlante: 'Integrazione Atlante',
    admSezioneIntegrazioneDinamico: 'Integrazione Dinamico (PHP e WSDynPkg)',
    admSezioneEmailComunicazioni: 'Email e Comunicazioni',
    admCreaSocieta: 'Crea Nuova Società',
    admModificaSocieta: 'Modifica Società',
    admSottotitoloSocieta: 'Configura le impostazioni e le integrazioni per la società',
    admEspandiTutto: 'Espandi tutto',
    admChiudiTutto: 'Chiudi tutto',
    admUsername: 'Username',
    admPassword: 'Password',
    admIdEnvironment: 'Id Environment',
    admRuolo: 'Ruolo',
    admAnagraficaUtente: 'Anagrafica utente',
    admCreaUtente: 'Crea Utente',
    admModificaUtente: 'Modifica Utente',
    admPID: 'PID',
    admEmail: 'Email',
    admTelefono: 'Telefono',
    admNome: 'Nome',
    admCognome: 'Cognome',
    admAnagraficaViaggiatore: 'Anagrafica viaggiatore',
    admCreaViaggiatore: 'Crea Viaggiatore',
    admModificaViaggiatore: 'Modifica Viaggiatore',
    admImportaViaggiatori: 'Importa viaggiatori',
    admSottotitoloImport: "Carica un file CSV per importare in blocco l'anagrafica viaggiatori",
    admCaricaCSV: 'Carica CSV',
    admCaricaSuDB: 'Carica su DB',
    admAnteprimaFile: 'Anteprima file caricato',
    admViaggiatoriDaImportare: ' viaggiatori da importare',
    admNienteDaVisualizzare: 'Niente da visualizzare',
    admTutorialUpload: "Effettua l'upload di un file CSV contentente i viaggiatori da aggiungere.",
    admTutorialStruttura: 'Il file CSV deve essere così strutturato: ',
    admTutorialIntestazione:
      'Nella prima riga di intestazione devono essere inseriti i campi pid, email, cellulare, codice cliente.',
    admTutorialDati: 'Dalla seconda riga devono essere inseriti i dati dei vari clienti.',
    admTutorialEsempio: 'Ecco un file di esempio da editare e caricare.',
    admScarica: 'Scarica',
    admAggiornaLabelErrori: 'Aggiorna label errori',
    admAggiornaLabelErroriHint:
      'Aggiorna la label degli errori per categorizzarli con la versione più recente del classificatore.',
    admAggiornaErroriTAProfile: 'Aggiorna errori TA profile',
    admAggiornaErroriTAProfileHint:
      'Ricalcola gli errori legati al profilo TA (anagrafica viaggiatori).',
    admAggiornaErroriOutOfOffice: 'Aggiorna errori out of office',
    admAggiornaErroriOutOfOfficeHint: 'Aggiorna la classificazione delle email out-of-office.',
    admSottotitoloPanel: 'Operazioni manutentive sui dati',
    admOperazioniManutenzione: 'Operazioni di manutenzione',
    admSottotitoloManutenzione: 'Eseguili con cautela · azioni non reversibili',
    admEsegui: 'Esegui',
    controlliIA: 'Controlli IA',
    cpDuplica: 'Duplica',
    cpSottotitoloPanel: 'Community Panel · Preset configurazione Nora',
    cpAggiungiFiltri: 'Aggiungi filtri',
    cpAggiungiFiltro: 'Aggiungi filtro…',
    cpNRimborsabili: 'N. rimborsabili',
    cpNNonRimborsabili: 'N. non rimborsabili',
    cpInserisciParametroRicerca: 'Inserire almeno un parametro di ricerca',
    cpErroreRicercaGruppo: 'Errore nella ricerca del gruppo',
    cpGruppoNonTrovato: 'Gruppo non trovato',
    cpPresetEsistente: 'Preset esistente',
    cpGruppoConfigurazioneEsistente: 'Questo gruppo ha già una configurazione salvata',
    cpClienteNonTrovato: 'Cliente non trovato',
    cpClienteConfigurazioneEsistente: 'Questo cliente ha già una configurazione salvata',
    cpCreaPreset: 'Crea Community Preset',
    cpModificaPreset: 'Modifica Community Preset',
    mxElencoPrompts: 'Elenco Prompts',
    mxPromptLLMSubtitle: 'Prompt LLM utilizzati per estrarre i campi delle conversazioni',
    mxCompilaCampi: 'Compilare tutti i campi',
    mxPromptCreato: 'Prompt creato',
    mxCreazionePrompt: 'Creazione Prompt',
    mxModificaPrompt: 'Modifica Prompt',
    mxConfigurazionePrompt: 'Configurazione prompt',
    mxChiaveCampoJson: 'Chiave campo JSON',
    mxSpiegazioneCampo: 'Spiegazione campo (basePrompt)',
    mxValidaTestLabel: "Vuoi validare il test? Il risultato dell'autotest verrà aggiornato",
    mxTestIdPrefix: 'Test ID: ',
    mxValidazioneEstrazione: 'Validazione estrazione dati conversazione',
    mxTestPrecedente: 'Test precedente',
    mxTestSuccessivo: 'Test successivo',
    mxEseguiTest: 'Esegui Test',
    mxValidaTest: 'Valida Test',
    mxConversazioneTest: 'Conversazione test',
    mxMessaggiSuffix: ' messaggi',
    mxRisultatoAtteso: 'Risultato atteso',
    mxRisultatoOttenuto: 'Risultato ottenuto',
    mxInEsecuzione: 'In esecuzione',
    mxImpostazioneCoefficienti: 'Impostazione coefficienti ricerca',
    mxImpostaCoefficientiPer: 'Imposta coefficienti per ',
    mxTipoPreventivo: 'Tipo Preventivo '
  },
  EN: {
    gf45Porte: '4-5 doors',
    gfAllInclusive: 'All Inclusive',
    gfAndataRitorno: 'Round trip',
    gfAutomatico: 'Automatic',
    gfBedAndBreakfast: 'Bed and Breakfast',
    gfCena: 'Dinner',
    gfCentrale: 'Middle',
    gfCompact: 'Compact',
    gfCorridoio: 'Aisle',
    gfEconomy: 'Economy',
    gfFinestrino: 'Window',
    gfFormatoData: 'Format dd/mm/yyyy',
    gfFullSize: 'Full size',
    gfIntermediate: 'Intermediate',
    gfLuxury: 'Luxury',
    gfManuale: 'Manual',
    gfMezzaPensione: 'Half board',
    gfMini: 'Mini',
    gfNo: 'No',
    gfNonPrecedentePartenza: 'Cannot be earlier than departure',
    gfNonSpecificato: 'Not specified',
    gfPensioneCompleta: 'Full board',
    gfPranzo: 'Lunch',
    gfPremium: 'Premium',
    gfSi: 'Yes',
    gfSolaAndata: 'One way',
    gfSoloNumeri: 'Numbers only',
    gfSoloStanza: 'Room only',
    gfStandard: 'Standard',
    gfSuv: 'SUV',
    gfVan: 'Van',
    mxAllInclusive: 'All Inclusive',
    mxBedAndBreakfast: 'Bed and Breakfast',
    mxCenaInclusa: 'Dinner included',
    mxCoeffDistanza: 'Distance coefficient',
    mxCoeffDurata: 'Duration coefficient',
    mxCoeffScostamento: 'Deviation coefficient',
    mxGruppoBase: 'Base',
    mxGruppoCorporate: 'Corporate',
    mxGruppoLivelliHotel: 'Hotel Program Levels',
    mxGruppoTrattamento: 'Treatment',
    mxLivello0: 'Level 0',
    mxLivello1: 'Level 1',
    mxLivello2: 'Level 2',
    mxLivello3: 'Level 3',
    mxMezzaPensione: 'Half board',
    mxPensioneCompleta: 'Full board',
    mxPranzoIncluso: 'Lunch included',
    mxRoomOnly: 'Room Only',
    mxTariffaAgenzia: 'Agency fare',
    mxTariffaCliente: 'Client fare',
    mxTariffaPubblica: 'Public fare',
    pfPreset24h: 'Last 24h',
    pfPreset30Giorni: 'Last 30 days',
    pfPreset6h: 'Last 6h',
    pfPreset7Giorni: 'Last 7 days',
    pfPresetUltimaOra: 'Last hour',
    pfStatoAttenzione: 'Warning',
    pfStatoCritico: 'Critical',
    pfStatoNormale: 'Normal',
    pfStepCompletato: 'Completed',
    admAbilitazioneArrivoEntro: 'Enable arrive-by',
    admAbilitazioneArrivoEntroDesc:
      'Enables setting the departure time of services to 00:01 if it is not specified but the arrive-by indication is present...',
    admAbilitazioneAtlante: 'Enable Atlante',
    admAbilitazioneAtlanteDesc: 'Enables the use of Atlante.',
    admAbilitazioneB4B: 'Enable B4B',
    admAbilitazioneB4BDesc: 'Enables integration with the B4B system',
    admAbilitazioneCarnet: 'Enable carnet',
    admAbilitazioneCarnetDesc: 'Enables the use of carnets.',
    admAbilitazioneMidOffice: 'Enable Mid Office',
    admAbilitazioneMidOfficeDesc: 'Enables the use of Mid Office.',
    admAbilitazioneRimborsabile: 'Enable refundable management',
    admAbilitazioneRimborsabileDesc:
      'Enables the management of refundable or non-refundable trains.',
    admBloccaEmailErroreOperatori: 'Block sending error emails to operators',
    admBloccaEmailErroreOperatoriDesc: 'Blocks sending error emails to operators',
    admCodiceMastroCliente: 'Customer Master Code',
    admCodiceMastroClienteDesc:
      'Master code to identify the customer (e.g.: 20 1 2 127, where 20 is the master)',
    admCodiceOperatore: 'Operator Code',
    admCodiceOperatoreDesc: 'Operator code for searching ATP generic tables',
    admCodiceProvenienza: 'Origin Code',
    admCodiceProvenienzaDesc: 'Origin code for ATP ticket tables',
    admCodiceSocieta: 'Company Code',
    admCodiceSocietaDesc: 'Unique code to identify the company',
    admCodiceTomcat: 'Tomcat Code',
    admCodiceTomcatDesc: 'Code of the associated Tomcat server',
    admConfigurazioneEmailReport: 'Email Report Configuration',
    admConfigurazioneEmailReportDesc:
      'JSON configuration for the credentials and settings for sending email from the platform. Example: {"host": "smtp.gmail.com", "port": 587, "secure": false, "auth": {"user": "email@example.com", "pass": "password"}}',
    admElencoEmailCCReport: 'List of CC emails for reports (comma-separated)',
    admElencoEmailCCReportDesc: 'List of CC emails for reports (comma-separated)',
    admDominioEmailOperatore: 'Operator email domain',
    admDominioEmailOperatoreDesc:
      'Fixed domain (e.g. bcdtravel.it) of operator emails in reports. Empty: full email.',
    admEstrapolazioneCampi1a10: 'Enable AI extraction of fields 1 to 10',
    admEstrapolazioneCampi1a10Desc: 'Enables AI extraction for fields 1-10',
    admFlussoRichiestaInfoGeneriche: 'Enable generic information request flow',
    admFlussoRichiestaInfoGenericheDesc: 'Enables the generic information request flow',
    admGestioneAuto: 'Enable car management',
    admGestioneAutoDesc: 'Enables the management of rental cars.',
    admGestioneGruppiPasseggeri: 'Enable passenger group management',
    admGestioneGruppiPasseggeriDesc: 'Enables the management of passenger groups.',
    admGoogleApiKey: 'Google API Key',
    admGoogleApiKeyDesc: 'API key for Google services',
    admInviaNotificaFormDati: 'Send data form completion notification',
    admInviaNotificaFormDatiDesc: 'Sends a data form completion notification',
    admInvioEmailRiassuntivoOperatore: 'Enable sending operator summary email',
    admInvioEmailRiassuntivoOperatoreDesc: 'Enables sending summary emails to operators',
    admLetturaAllegatiEmail: 'Enable reading of email attachments',
    admLetturaAllegatiEmailDesc: 'Enables reading of email attachments',
    admLetturaOggettoEmail: 'Enable reading of email subject',
    admLetturaOggettoEmailDesc:
      'Enables reading and analysis of the email subject and the possible merge with the data extracted from the message body.',
    admLetturaStoricoViaggiatore: 'Enable reading of the traveller profile history',
    admLetturaStoricoViaggiatoreDesc: 'Enables reading of the traveller profile history',
    admNomeDbB4B: 'B4B DB Name',
    admNomeDbB4BDesc: 'Name of the B4B database',
    admNomeDbDinamico: 'Dynamic DB Name',
    admNomeDbDinamicoDesc: 'Name of the Dynamic database',
    admNomeDesc: 'Identifying name of the company',
    admNumeroMassimoMessaggiAI: 'Maximum number of AI messages',
    admNumeroMassimoMessaggiAIDesc: 'Maximum number of allowed AI messages (default: 5)',
    admPasswordB4B: 'B4B Password',
    admPasswordB4BDesc:
      'Password for the B4B database (password encrypted with an external script)',
    admPasswordDbDinamico: 'Dynamic DB Password',
    admPasswordDbDinamicoDesc:
      'Password for the Dynamic database (password encrypted with an external script)',
    admPasswordJavaWsDinamico: 'Dynamic Java WS Password',
    admPasswordJavaWsDinamicoDesc:
      'Password for DynJavaWS (password encrypted with an external script)',
    admPasswordWS: 'WS Password',
    admPasswordWSDesc:
      'Password for web service authentication (password encrypted with an external script)',
    admPortaB4B: 'B4B Port',
    admPortaB4BDesc: 'Port of the B4B database',
    admPortaDbDinamico: 'Dynamic DB Port',
    admPortaDbDinamicoDesc: 'Port of the Dynamic database',
    admPresaInCarico: 'Enable "take charge"',
    admPresaInCaricoDesc: 'Enables the ability to take charge of a conversation',
    admPuliziaPPI: 'Enable PPI cleaning',
    admPuliziaPPIDesc: 'Enables the cleaning of personally identifiable information (PPI).',
    admResocontoOperatore: 'Enable operator report',
    admResocontoOperatoreDesc:
      'Enables the creation of the business trip report to be sent to the operator both in case of success and in case of error.',
    admSaltoRicercaTreni: 'Skip train search on dynamic',
    admSaltoRicercaTreniDesc: 'Skips the train search on dynamic',
    admSanitizzazioneEmailSenzaAI: 'Enable email sanitization without AI',
    admSanitizzazioneEmailSenzaAIDesc: 'Enables email sanitization without using AI',
    admTargetPacchettoDinamico: 'Dynamic Package Target',
    admTargetPacchettoDinamicoDesc: 'Target of the dynamic package (Test/Production)',
    admTelefonoWhatsapp: 'WhatsApp Phone',
    admTelefonoWhatsappDesc: 'Phone number for WhatsApp',
    admUrlAtlante: 'Atlante URL',
    admUrlAtlanteDesc: 'URL of the Atlante service for bookings',
    admUrlB4B: 'B4B URL',
    admUrlB4BDesc: 'URL of the B4B database',
    admUrlDbDinamico: 'Dynamic DB URL',
    admUrlDbDinamicoDesc: 'URL of the Dynamic database',
    admUrlDinamicoPhp: 'Dynamic PHP URL',
    admUrlDinamicoPhpDesc: 'URL of the Dynamic PHP service',
    admUrlJavaWsDinamico: 'Dynamic Java WS URL',
    admUrlJavaWsDinamicoDesc: 'URL of the Dynamic Java WS service',
    admUtenteB4B: 'B4B User',
    admUtenteB4BDesc: 'Username for the B4B database',
    admUtenteDbDinamico: 'Dynamic DB User',
    admUtenteDbDinamicoDesc: 'Username for the Dynamic database',
    admUtenteJavaWsDinamico: 'Dynamic Java WS User',
    admUtenteJavaWsDinamicoDesc: 'Username for Dynamic Java REST',
    admUtenteWS: 'WS User',
    admUtenteWSDesc: 'Username for web service authentication',
    admVisualizzaBottoneReport: 'Show report button',
    admVisualizzaBottoneReportDesc: 'Shows the button for reports',
    cerca: 'Search...',
    conversazioni: 'Conversations',
    cpCompilatoDaNora: 'filled in by Nora',
    data: 'Date',
    errAeroportoIATAnotFound: 'Airport IATA not found',
    errAttachmentsInEmail: 'Internal attachments in email',
    errCanceled: 'Cancelled by operator',
    errCarnetError: 'Carnet search error',
    errDefault: 'Other',
    errDepartureCarJsonNotFound: 'Car departure/arrival data not found',
    errDestinationHotelNotFound: 'Hotel destination not found',
    errDuplicazioneProfiloTrovato: 'Duplicate profile found',
    errEmailMancanteProfiloViaggiatore: 'Missing traveler profile email',
    errErroreCreazionePreventivi: 'Quotes creation error',
    errErroreCreazioneServizi: 'Services creation error',
    errErroreCreazioneTrasferta: 'Trip creation error',
    errErroreElaborazioneServizi: 'Services processing error',
    errErroreRicercaDinamico: 'Dynamic search error',
    errErroreRicercaDinamicoVuoto: 'No service search results',
    errErrorSavingAttachments: 'Error saving attachments',
    errGenericError: 'Generic error',
    errLoopError: 'Loop error',
    errMaxAIMessagesReachedInGC: 'Generic content (not a trip)',
    errMoreThanOneTransfer: 'More than one trip found',
    errNessunProfiloTrovato: 'No profile found',
    errNessunProfiloTrovatoTA: 'TA missing on traveler',
    errNoAirportFound: 'Airport not found',
    errNoFinalizzazioneCorretta: 'Finalization did not occur',
    errNoKeyServizioGenerato: 'Missing service key',
    errNoNoraTransfer: 'Trip not created by Nora',
    errNonTrovatoRiferimentoServizioSuMidOffice: 'Service reference not found in mid office',
    errNoProfileInfoTrovato: 'Profile not found',
    errNoTransferFound: 'No trip found',
    errOutOfOffice: 'Out of office',
    errPasseggeriMultipli: 'Multiple passengers',
    errProfiloMittenteNonTA: 'Sender profile is not Travel Arranger',
    errProfiloNoPresenteSuGDS: 'Profile not present on GDS',
    errRichiestaAggiornamentoTrasferta: 'Trip update request',
    errRichiestaModificaOCancellazioneTrasferta: 'Trip modify/cancel request',
    errSollecito: 'Reminder',
    errTooManyDaysHotel: 'Hotel stay too long',
    errTooManyMessages: 'Message limit reached',
    errTooMuchServiceBoth: 'Too many train and plane services',
    errTooMuchServicePlane: 'Too many plane services',
    errTooMuchServiceTrain: 'Too many train services',
    gfDi: 'of',
    gfNumerico: 'numeric',
    gfReturnLeg: 'Return leg',
    gfSeleziona: 'Select',
    gfSelezionaData: 'Select date',
    gfServizioCopertoDaCarnet: 'Service covered by CARNET',
    gfTransferDepartureDate: 'Departure date',
    gfTransferDeparturePlace: 'Place of departure',
    gfTransferDestinationPlace: 'Place of destination',
    gfTransferNumPax: 'Number of passengers',
    gfTransferReturnDate: 'Return date',
    mcApri: 'open',
    mcAutotestAggiornato: 'Autotest updated',
    mcConversazioneIniziataIl: 'Conversation started on',
    mcCopiatoNegliAppunti: 'Copied to clipboard',
    mcCredenzialiErrate: 'Wrong credentials',
    mcDebug: 'Debug',
    mcErroreImprevisto: 'Sorry, an unexpected error occurred.',
    mcFilenameLabel: 'filename',
    mcMe: 'Me',
    mcNameLabel: 'name',
    mcOggetto: 'Subject',
    mcOoops: 'Ooops!',
    mcPayloadCopiato: 'The payload was copied to the clipboard',
    mcRichiestaViaggio: 'Travel request',
    mcScriviMessaggio: 'Write a message...',
    mcTestNonTrovato: 'Test not found',
    mxErroreImportazioneViaggiatori: 'Error while importing travellers',
    mxGestisciNoraAI: 'Manage Nora AI',
    mxTitoloPanelOperations: 'Panel Operations',
    mxTrovati: 'Found',
    mxViaggiatori: 'travellers',
    pfCanale: 'channel',
    pfCosto: 'Cost',
    pfDatiCacheProcessOverview:
      'Data from the processOverviewHourly cache table (aligned to conversations in the period).',
    pfFinalState: 'Final State',
    pfInitialState: 'Initial State',
    pfMediaBin: 'Avg/bin',
    pfOrdinateDecrescente: 'sorted descending',
    pfProcessi: 'Processes',
    pfScatterCacheHint:
      'Points from the processOverviewHourly cache table (samples per hour). Click to open the process.',
    pfScatterCacheHintLong:
      'Points from the processOverviewHourly cache table (samples per hour, max 5000 total points). Click to open the process.',
    pfStato: 'State',
    pfStep: 'steps',
    pfTokenRichieste: 'Tokens/Requests',
    pfTotaleCache: 'Total (cache)',
    pfUnitSelezionate: 'units selected',
    stCosto: 'Cost',
    tdAereo: 'Plane',
    tdAeroportoArrivo: 'Arrival airport',
    tdAeroportoArrivoNonValido: 'Invalid arrival airport',
    tdAeroportoPartenza: 'Departure airport',
    tdAeroportoPartenzaNonValido: 'Invalid departure airport',
    tdAnteprimaRisultatiDinamico: 'Dynamic results preview',
    tdArrivo: 'Arrival',
    tdCamera: 'Room',
    tdCerca: 'Search',
    tdCitta: 'City',
    tdCittaNonValida: 'Invalid city',
    tdClasse: 'Class',
    tdCompagnia: 'Company',
    tdCoordinate: 'Coordinates',
    tdDataArrivo: 'Arrival Date',
    tdDataCancellazione: 'Cancellation Date',
    tdDataCheckIn: 'Check In Date',
    tdDataCheckOut: 'Check Out Date',
    tdDataPartenza: 'Departure Date',
    tdDistanza: 'Distance',
    tdDurata: 'Duration',
    tdEchoToken: 'Echo Token',
    tdFormatoDataOraNonValido: 'Invalid date/time format',
    tdFormatoDateNonValido: 'Invalid date format',
    tdHotel: 'Hotel',
    tdIdCommunity: 'Community Id',
    tdIndirizzo: 'Address',
    tdKgBagaglio: 'Baggage Kg',
    tdLat: 'Lat',
    tdLatitudine: 'Latitude',
    tdLng: 'Lng',
    tdLongitudine: 'Longitude',
    tdMetri: 'meters',
    tdMiniRules: 'Mini Rules',
    tdOraArrivo: 'Arrival Time',
    tdOraPartenza: 'Departure Time',
    tdPartenza: 'Departure',
    tdPreferenzaPosto: 'Seat preference',
    tdPrezzo: 'Price',
    tdPrezzoAncillary: 'Price + Ancillary',
    tdRisultati: 'results',
    tdServiziAggiuntivi: 'Additional services',
    tdSottotitoloAnteprima: 'View the raw results returned by the search engine',
    tdStazioneArrivo: 'Arrival Station',
    tdStazioneArrivoNonValida: 'Invalid arrival station',
    tdStazionePartenza: 'Departure Station',
    tdStazionePartenzaNonValida: 'Invalid departure station',
    tdTariffa: 'Fare',
    tdTipo: 'Type',
    tdTipoRicerca: 'Search Type',
    tdTratta: 'Route',
    tdTrattamento: 'Treatment',
    tdTrattaN: 'Route No.',
    tdTreno: 'Train',
    tdTypeRoom: 'Room type',
    abilitaMessaggiFirmati: 'Enable messages signed with Nora name',
    abilitaMessaggiFirmatiDescrizione:
      "If enabled, messages sent to the user will be signed with the name 'Nora' to ensure a more personalized experience.",
    abilitaMessaggioFinale: 'Enable sending a final message to the trip requester',
    abilitaMessaggioFinaleDescrizione:
      'If enabled, an informational message is sent to the trip requester at the end of the procedure. (textual or with the link in case of automatically generated quotes)',
    abilitato: 'Enabled',
    abilitazioneStepAvanzamento: 'Enable progress steps:',
    active: 'Active',
    aggiungiFarreTreno: 'Add fare',
    aggiungiInformazioniMeteo: 'Add weather information to the message',
    aggiungiInformazioniMeteoDescrizione:
      'If enabled, the message will include weather forecasts for the trip period, providing useful details for planning.',
    aggiungiServizio: 'Add Service',
    aereo: 'Plane',
    aic: 'AIC',
    adminCoefficients: 'Admin Coefficients',
    annulla: 'Cancel',
    attachmentsInEmail: 'Attachments in email',
    auto: 'Car',
    autoTest: 'Auto Test',
    azioni: 'Actions',
    bestBuy: 'Best buy',
    cancellata: 'Canceled',
    caricamento: 'Loading...',
    chat: 'Chat',
    chooseClientGroupClient: 'Client',
    chooseClientGroupDefault: 'Select an option...',
    chooseClientGroupGroup: 'Group',
    clickToPreviewMessage: "Click 'Preview message' to view the body in a new window",
    codice: 'Code',
    codiceCliente: 'Client Code',
    codiceGruppo: 'Group Code',
    communityPanel: 'Community Panel',
    communityPresetsList: 'Community Preset List',
    compagniaTreno: 'Train Company',
    compilareCampiObbligatori: 'Fill in all required fields',
    conferma: 'Confirm',
    confermaInvio: 'Confirm Send',
    conto: 'Account',
    controllaPreventivi: 'Check quotes',
    controllaPreventiviDescrizione:
      "If enabled, the quotes are not sent to the traveler but are created in the 'in progress' state for review",
    conversations: 'Conversations',
    createNew: 'Create New',
    creationDate: 'Creation Date',
    creato: 'Created',
    creazionePreventivo: 'Create quote',
    creazioneTrasfertaServizi: 'Create trip and services',
    currentIsola: 'Current Island',
    datiTrasferta: 'Trip Data',
    datiViaggiatore: 'Traveler Data',
    defaultPreset: 'Default Preset',
    deleteDefaultPresetError: 'Cannot delete the default preset',
    deleteServiceHeader: 'Service Deletion',
    deleteServiceLabel: 'Do you want to delete this service?',
    deleteSuccess: 'Deletion successful',
    descrizione: 'Description',
    distance: 'Distance',
    duplicazioneProfiloTrovato: 'Duplicate traveler profile, homonymy found',
    duration: 'Duration',
    dynamicTest: 'Dynamic Test',
    elaborazioneMessaggioInCorso: 'Processing message in progress',
    elaborazioneMessaggioInCorsoDetails: 'Processing message in progress... wait for completion.',
    error: 'Error',
    errore: 'Error',
    escludiNora: 'Exclude Nora',
    formale: 'Formal',
    formaleDefault: 'formal (default)',
    gestireDaMidoffice: 'Handle from Midoffice',
    gestireManualmente: 'Handle manually from Midoffice',
    gestisciNoraAI: 'Manage Nora AI',
    gruppo: 'Group',
    hotel: 'Hotel',
    hotelAutomatico: 'Automatic hotel',
    hotelAutomaticoDescrizione:
      'If the trip lasts multiple days, the hotel is automatically added.',
    id: 'Id',
    identificativoAnno: 'Year Identifier',
    identificativoPratica: 'Practice Identifier',
    identificativoRichiesta: 'Request Identifier',
    ignorata: 'Ignored',
    impostazionePreventiviGenerati: 'Generated quotes setting',
    impostazioni: 'Settings',
    impostazioniSistema: 'System Settings',
    salvataggioEffettuato: 'Save successful',
    stateDiffDescrizione:
      'If enabled, new conversations will use the State Diff format for process history. Existing conversations are not affected.',
    nessunRecordSistema: 'No system record found in the database.',
    inAttesaDiConferma: 'Awaiting confirmation',
    inEsecuzione: 'In progress',
    inactive: 'Inactive',
    indicateFormalityLevel: 'Indicate formality level',
    indietro: 'Back',
    informale: 'Informal',
    inserireDatiViaggiatore: 'Enter traveler data',
    logicaCameraNonInPenale: 'Non-penalty room logic',
    logicaCameraNonInPenaleDescrizione1:
      'If the hotel is subject to penalties, the first non-penalty room in the same hotel will be searched.',
    logicaCameraNonInPenaleDescrizione2: "If unavailable, the 'best buy' room will be selected.",
    login: 'Login',
    logout: 'Logout',
    mastro: 'Ledger',
    messaggioLink: 'Within the message where it appears:',
    messaggioLinkPreventivi: "-'#link': the link to view the quotes will be inserted",
    messaggioMeteo:
      '-\'#meteo\': weather information will be inserted (if the trip request is within 5 days of departure). To display the phrase, the "Include weather information" flag must be enabled.',
    messaggioPreimpostatoUtente: 'Predefined message for user',
    messaggioPreimpostatoUtenteDescrizione:
      'If selected, the traveler will be notified that their request is being handled by a real operator.',
    messaggioPreventivi: 'Message for quotes:',
    messaggioReindirizzamentoOperatore: 'Message for operator redirection:',
    messaggioReindirizzamentoOperatoreDescrizione:
      'Predefined message to send to the user in case of redirection to the operator',
    modificaViaggiatore: 'Edit traveler',
    moltoFormale: 'Very formal',
    nProposte: 'N. Quotes',
    nessunProfiloTrovato: 'Profile not found',
    nessunProfiloTrovatoTA: 'Traveler and TA link not found',
    profiloMittenteNonTA: 'Sender profile not Travel Arranger',
    nessunServizioInserito: 'No service entered',
    nessunServizioTrenoInserito: 'No train service entered',
    nessunServizioHotelInserito: 'No hotel service entered',
    nessunServizioAereoInserito: 'No flight service entered',
    nessunServizioAutoInserito: 'No car service entered',
    servizioEmptyHint: 'Add it only if requested in the conversation',
    no: 'No',
    noConversationsFound: 'No conversations found',
    noPresetFound: 'No preset found',
    noProfileInfoTrovato: 'Traveler profile not found',
    noraEsclusa: 'Nora Excluded',
    operations: 'Operations',
    operatoreCreazionePratica: 'Practice creation operator',
    outOfOffice: 'Out of office',
    sollecito: 'Follow-up reminder',
    maxAIMessagesReachedInGC: 'Generic content (not a travel request)',
    panelOperations: 'Panel Operations',
    performanceMonitor: 'Performance Monitor',
    passeggeriMultipli: 'Multiple passengers identified',
    pocoFormale: 'Not formal',
    prendiInCarico: 'Take charge',
    presetAbilitato: 'Preset enabled',
    previewMessage: 'Preview Message',
    price: 'Price',
    processes: 'Processes',
    prontoARipartire: 'In progress',
    pubblicaLoStesso: 'Publish anyway',
    pubblicaLoStessoDescrizione:
      'If no results are found for one of the requested services, the quotes are still published',
    raccoltaInformazioni: 'Information gathering',
    ragioneSociale: 'Company Name',
    requester: 'Requester',
    ricercaCliente: 'Client Search',
    ricercaGruppo: 'Group Search',
    ricercaPer: 'Search by',
    richiediMezzoTrasporto: 'Request transport if not specified',
    richiediMezzoTrasportoDescrizione:
      'If enabled, the user will be asked if they want an air or rail service to reach the destination if not already specified.',
    richiestaModificaOCancellazioneTrasferta: 'Request to modify or cancel trip',
    richiestaAggiornamentoTrasferta: 'Request trip information update',
    salva: 'Save',
    selectEmail: 'Select Email',
    selectEmailRedirect: 'Select Email Redirect To Operator',
    selectEnvironment: 'Select Environment',
    selectEnvironmentPlaceholder: 'Select Environment',
    selectFormalityLevel: 'Select formality level',
    selectPID: 'Select PID',
    selectUnit: 'Select unit to execute',
    selectUnitToExecute: 'Select unit to execute',
    selectedDate: 'Selected Date',
    seleziona: 'Select',
    selezionaPrioritaServizio: 'Select service priority',
    selezionaPrioritaTariffa: 'Select train fare priority',
    selezionaRicerca: 'Select search',
    tariffeRimborsabili: 'Refundable Fares',
    tariffeNonRimborsabili: 'Non-Refundable Fares',
    selezionato: 'Selected',
    serviziAereo: 'Air Services',
    serviziAuto: 'Car Services',
    serviziHotel: 'Hotel Services',
    serviziTreno: 'Train Services',
    servizio: 'Service',
    societyList: 'Company List',
    soloCamereNonInPenale: 'Only non-penalty rooms',
    soloCamereNonInPenaleDescrizione:
      'If no non-penalty rooms are found in a hotel, move to the next hotel and repeat up to 10 attempts.',
    sottoConto: 'Sub Account',
    state: 'Status',
    stepNascostoB4B:
      'This step is selected but B4B integration is disabled. Select another step or re-enable B4B.',
    statistics: 'Statistics',
    success: 'Success',
    terminato: 'Completed',
    time: 'Time',
    tipo: 'Type',
    tipologiaTariffa: 'Fare Type',
    titolo: 'Title',
    titoloPreset: 'Preset Title',
    tolleranzaGiorniPenale: 'Penalty Days Tolerance',
    tonoEmail: 'Email tone:',
    tornaIndietro: 'Go Back',
    trasfertaCreata: 'Trip created',
    travellersList: 'Travelers List',
    treno: 'Train',
    usaPresetDefault: 'Use preset as default',
    userList: 'User List',
    users: 'Users',
    verificaConfermaDatiIA: 'Verify and confirm AI-generated data',
    verificaConfermaDatiIADescrizione:
      "After data collection, the operator must review and confirm the information entered by the AI in the 'Operator Form' section.",
    vuoiConfermareDati: 'Do you want to confirm the data?',
    vuoiPrendereInCarico: 'Do you want to take charge of the conversation?',
    gfAttendiCompletamentoTrasferta: 'Wait for completion to edit the trip',
    gfAvviata: 'Started',
    gfCampi: 'fields',
    gfCampiDaCompilare: 'to fill in',
    gfCampiDaRivedere: 'to review',
    gfCampiObbligatoriDaCompilare: 'required to fill in',
    gfCampiObbligatoriMancanti: 'REQUIRED FIELDS MISSING',
    gfCampiPersonalizzati: 'Custom fields',
    gfCampo: 'field',
    gfCampoObbligatorio: 'Required field',
    gfCampoObbligatorioMancante: 'REQUIRED FIELD MISSING',
    gfCaricamentoProfilo: 'Loading profile',
    gfCaricamentoProfiloDettaglio: 'Please wait while the selected traveler data is retrieved…',
    gfCerca: 'Search',
    gfChiudiAnteprima: 'Close preview',
    gfAllegati: 'Attachments',
    gfAllegatoFile: 'File',
    gfAllegatiNelCorpoEmail:
      'Images embedded in the email body (usually shown inline in the message above)',
    gfInCorpoEmail: 'email body',
    gfChatComposerPlaceholder: 'Write a message… Enter to send, Shift+Enter for new line',
    gfChatSend: 'Send message',
    gfAudio: 'Audio',
    gfComprimi: 'Collapse',
    gfContieneErrori: 'contains errors',
    gfContieneErroriTitle: 'Contains errors',
    gfConversazioneNonTrovata: 'Conversation not found',
    gfDaRivedere: 'To review',
    gfEspandi: 'Expand',
    gfImmagine: 'Image',
    gfLetto: 'read',
    gfConversazione: 'Conversation',
    gfConversazioneConNora: 'Conversation with Nora',
    gfConversazionePrecedente: 'Previous conversation',
    gfConversazioneSuccessiva: 'Next conversation',
    gfConv: 'Conv.',
    gfCreaTest: 'Create test',
    gfDa: 'from',
    gfDeleteServiceLabelIrreversible:
      'Do you want to delete this service? This action cannot be undone.',
    gfEliminaServizio: 'Delete service',
    gfElaborazioneInCorso: 'Processing in progress',
    gfErroreAggiornamentoState: 'State update error',
    gfErroreCaricamentoViaggiatore: 'Error loading traveler',
    gfErroreConfermaForm: 'Form confirmation error',
    gfErroreCreazioneTest: 'An error occurred while creating the test',
    gfErroreInvioSegnalazione: 'Error sending report',
    gfErroreRicercaViaggiatore: 'Error searching for traveler',
    gfEsclusioneNora: 'Exclude Nora',
    gfEscludiNoraSub: 'Upcoming messages must be handled by mid-office only.',
    gfFiltrato: 'Filtered',
    gfFormInviatoSuccesso: 'Form submitted successfully',
    gfHaPrecompilato: 'prefilled',
    gfHintRicercaViaggiatore: 'Enter first name and last name and/or email to search',
    gfInvia: 'Send',
    gfInviaSegnalazione: 'Send report',
    gfModificaTrasferta: 'Edit trip',
    gfMostraTutteSezioni: 'Show all sections',
    gfMostraSoloSezioniDaRivedere: 'Show only sections with fields to review',
    gfNessunViaggiatoreTrovato: 'No traveler found',
    gfNessunViaggiatoreTrovatoHint: 'Try changing first name, last name or email and search again.',
    gfNoteSegnalazione: 'Report notes',
    gfEmailOperatoreSegnalazione: 'Your email',
    gfEmailOperatoreSegnalazioneHint:
      'We will use this address to reply to you. It will be remembered for future reports.',
    gfEmailOperatoreSegnalazioneNonValida: 'Enter a valid email address',
    gfNuovaTrasferta: 'New trip',
    gfNuovaConversazione: 'New conversation',
    gfOperazioneSuccesso: 'Operation completed successfully',
    gfPerCreareTrasferta: 'to create the trip',
    gfPerModificareConversazione: 'Take charge of the conversation to edit it',
    gfProntaDaCreare: 'Ready to create',
    gfProcessi: 'Processes',
    gfPulisciCampi: 'Clear fields',
    gfRicercaInCorso: 'Searching',
    gfRicercaInCorsoDettaglio: 'Searching for profiles matching your criteria…',
    gfRicercaPuntini: 'Searching…',
    gfRicercaViaggiatore: 'TRAVELER SEARCH',
    gfRimuovi: 'Remove',
    gfRimuoviServizio: 'Remove service',
    gfRisultatoTrovato: 'result found',
    gfRisultatiTrovati: 'results found',
    gfRisolviErroriIn: 'Fix errors in',
    gfSalvaBozza: 'Save draft',
    gfSelezionaViaggiatore: 'Select a traveler',
    gfSegnalazioneInviata: 'Report sent',
    gfSegnalazioneInviataSuccesso: 'The report was sent successfully',
    gfSezioniForm: 'Form sections',
    gfServizio: 'service',
    gfServizi: 'services',
    gfSolaLettura: 'read only',
    gfSoloDaRivedere: 'Review only',
    gfStateAggiornatoSuccesso: 'State updated successfully',
    gfTestCreato: 'Test created',
    gfTestCreatoSuccesso: 'The test was created successfully',
    gfTrasferta: 'Trip',
    gfTuttiCampiObbligatoriCompilati: 'All required fields are filled in.',
    gfVaiAProcessi: 'Go to processes',
    gfViaggiatore: 'Traveler',
    gfVuoiEscludereNora: 'Do you want to exclude Nora from the conversation?',
    gfVuoto: 'Empty',
    // Login
    loginTitle: 'Sign-in to Dashboard',
    loginButton: 'Login',
    poweredBy: 'Powered by',
    // Admin lists
    societyListTitle: 'Company List',
    societyCode: 'Company Code',
    societyNameCol: 'Company Name',
    urlAtlante: 'Atlante Url',
    noSocietyFound: 'No company found',
    deleteSocietyHeader: 'Company Deletion',
    deleteSocietyMessage: 'Do you want to delete this company?',
    userListTitle: 'User List',
    noUserFound: 'No user found',
    deleteUserHeader: 'User Deletion',
    deleteUserMessage: 'Do you want to delete this user?',
    travellersListTitle: 'Travelers List',
    noTravellerFound: 'No traveler found',
    deleteTravellerHeader: 'Traveler Deletion',
    deleteTravellerMessage: 'Do you want to delete this traveler?',
    importTravellers: 'Import travelers',
    phone: 'Phone',
    client: 'Client',
    // Process
    processListTitle: 'Process List',
    goToForm: 'Go to form',
    pricing: 'Pricing',
    noProcessFound: 'No process found',
    processId: 'Process Id',
    openStep: 'Open step',
    conversation: 'Conversation',
    messages: 'messages',
    readOnly: 'Read only',
    continueExecution: 'Continue execution',
    processErrors: 'Process Errors',
    processStats: 'Process Statistics',
    processComparison: 'Process Comparison',
    // Filters
    filters: 'Filters',
    date: 'Date',
    island: 'Island',
    allIslands: 'All islands',
    allStates: 'All states',
    search: 'Search',
    searchPlaceholder: 'Search by name, email, AIC...',
    searchConversations: 'Global conversations search',
    clearSearch: 'Clear search',
    resetFilters: 'Reset filters',
    removeAllFilters: 'Remove all filters',
    activeFilterOne: 'active',
    activeFilterMany: 'active',
    // Conversation actions
    viewDetail: 'View conversation detail',
    open: 'Open',
    warningConversationPending: 'Warning: conversation pending',
    conversationPending: 'Conversation pending',
    tripsInProgress: 'Trips in progress',
    // Theme
    switchToLight: 'Switch to light theme',
    switchToDark: 'Switch to dark theme',
    // Menu
    dashboardPricing: 'Dashboard Pricing',
    prompts: 'Prompts',
    home: 'Home',
    // ActiveFilterChips
    conversationSingular: 'conversation',
    conversationPlural: 'conversations',
    removeFilterDate: 'Remove date filter',
    removeFilterIsland: 'Remove island filter',
    removeFilterState: 'Remove state filter',
    removeSearch: 'Remove search',
    // Community alerts
    linkMissing: 'Link missing',
    linkMissingDetail: "Missing '#link' in quotes message",
    weatherInfoMissing: 'Weather info missing',
    weatherInfoMissingDetail: "Missing '#meteo' in quotes message",
    titleMissing: 'Title missing',
    selectGroupOrClient: 'Select a group or a client or select as default preset',
    groupNotFound: 'Group not found',
    // Chat
    testChat: 'Test Chat',
    testChatSubtitle: 'Execute a specific unit simulating a complete conversation',
    testParameters: 'Test parameters',
    testConversation: 'Test conversation',
    warning: '⚠️',
    yes: 'Yes',
    // Common
    modifica: 'Edit',
    elimina: 'Delete',
    chiudi: 'Close',
    dataInizio: 'Start date',
    dataFine: 'End date',
    giornoPrecedente: 'Previous day',
    giornoSuccessivo: 'Next day',
    dataDa: 'Date from',
    dataA: 'Date to',
    periodo: 'Period',
    tutti: 'All',
    media: 'Average',
    errori: 'Errors',
    nessunDatoDisponibile: 'No data available',
    totale: 'Total',
    processo: 'Process',
    rimuovi: 'Remove',
    secondi: 'seconds',
    minuti: 'minutes',
    eWord: 'and',
    nonTerminato: 'Not completed',
    // Gigi FilterBar
    filtraPerDataIsolaStato: 'Filter by date, island, state or free search',
    // Process/Conversations
    listaConversazioni: 'Conversations List',
    gestioneConversazioniPerData: 'Manage conversations by date',
    filtraPerData: 'Filter by date',
    viaggiatore: 'Traveler',
    conversazioneChiusa: 'Conversation closed',
    erroreChiusuraConversazione: 'Error closing conversation',
    // Process/Editor
    processStepsVisualizer: 'Process Steps Visualizer',
    differenzeStati: 'State Differences',
    statoStep: 'Step state',
    selezionaTipoOperazione: 'Select the type of operation',
    workflow: 'Workflow',
    riesecuzioneUnit: 'Unit re-execution',
    selezionaRieseguiStep: 'Select Re-execute on a step',
    finalState: 'Final State',
    rieseguiUnaUnit: 'Re-execute a unit',
    esecuzioneInCorso: 'Execution in progress…',
    rieseguiUnit: 'Re-execute unit',
    visualizzaErrore: 'View error',
    errorePrefix: 'Error: ',
    logLabel: 'Logs',
    initialState: 'Initial State',
    initialStack: 'Initial Stack',
    finalStack: 'Final Stack',
    inCorso: 'in progress…',
    // Process/ErrorStats
    statisticheErroriPerIntervallo: 'Error statistics by date range',
    intervalloDate: 'Date range',
    processiInErrore: 'Processes with errors',
    unitInErrore: 'Units with errors',
    nonCiSonoErrori: 'No errors found',
    dettaglioProcessiErrore: 'Error processes detail',
    // Process/Performance
    panoramica: 'Overview',
    performanceUnitTab: 'Unit Performance',
    trendAnalisi: 'Trends & Analysis',
    statisticheErrori: 'Error statistics',
    selezionaRange: 'Select a range or use quick presets',
    cacheAggiornata: 'Cache updated',
    erroreBackfillCache: 'Cache backfill error',
    erroreSconosciuto: 'unknown error',
    nessunDatoCache:
      'No data in processOverviewHourly cache for this range. Run "Backfill cache" with the same range (or wait for the cron every 10 minutes for the latest hours).',
    backfillCache: 'Backfill cache',
    aggiornamentoCache: 'Updating cache...',
    backfillCacheStatistiche: 'Statistics cache backfill',
    precomputaDescrizione:
      'Precompute unitStatsHourly and processOverviewHourly (performance and overview cache).',
    preset: 'Preset',
    oreCustom: 'Custom hours',
    rangePagina: 'Page range',
    oreDaRicalcolare: 'Hours to recalculate',
    eseguiBackfill: 'Execute backfill',
    selezioneGrafico: 'Chart selection: use the "Chart" button in the table.',
    caricamentoDatiCache: 'Loading cache data…',
    cache: 'Cache',
    unit: 'unit',
    // Process/Performance DrillDown
    dettaglio: 'Detail:',
    mostraTutti: 'Show all',
    soloLenti: 'Slow only',
    nessunaEsecuzioneTrovata: 'No execution found',
    tempo: 'Time',
    inizio: 'Start',
    conv: 'Conv.',
    // Process/Performance UnitStatsTable
    statistichePerUnit: 'Statistics by Unit',
    unitNelPeriodo: 'units in period',
    legenda: 'Legend',
    cercaUnit: 'Search unit...',
    evidenziazioneRighe: 'Row highlighting',
    tutte: 'All',
    soloEvidenziate: 'Highlighted only',
    soloNonEvidenziate: 'Not highlighted only',
    aggiungiAlGrafico: 'Add to chart',
    drillDown: 'Drill down',
    legendaColoriRegole: 'Color legend and rules',
    nelPeriodo: 'In period',
    deltaVsMediaComplessiva: 'Δ vs overall average',
    colAzioni: 'Actions',
    colN: 'N.',
    colErrPerc: 'Err%',
    colP90Media: 'P90÷Avg',
    colDeltaMedia: 'Δ Avg',
    colDeltaP50: 'Δ P50',
    colDeltaP90: 'Δ P90',
    colDeltaP95: 'Δ P95',
    colDeltaP99: 'Δ P99',
    // Process/Pricing
    costoLlmProcessi: 'LLM cost for conversation processes',
    filtraProvider: 'Filter providers',
    selezionaProviderVisualizzare: 'Select providers to display',
    dettaglioCostiUnit: 'Cost details by unit',
    ripartizioneCosti: 'Cost breakdown',
    perProvider: 'By provider',
    nessunCostoVisualizzare: 'No cost to display for selected providers.',
    // Process/Stats
    statoProcessSteps: 'Process steps status',
    processStepsInErrore: 'Process Steps with errors',
    riepilogoCosti: 'Cost Summary',
    tempiDiEsecuzione: 'Execution times',
    tempoDiEsecuzione: 'Execution time:',
    tempiUnit: 'Unit times',
    min: 'Min',
    max: 'Max',
    sommaUnit: 'Unit sum:',
    ordineEsecuzione: 'Execution order',
    durata: 'Duration',
    // Prompts
    prompt: 'Prompt',
    campo: 'Field',
    spiegazione: 'Explanation',
    nessunPromptInserito: 'No prompt found',
    // Statistics
    selezionaPeriodoAnalisi: 'Select the analysis period or use quick presets',
    selezionaPeriodoLabel: 'Select period:',
    filtraPerIsolaUnitaCliente: 'Filter by island, operational unit or client',
    unitaOperativa: 'Operational unit',
    tutteLeUnitaOp: 'All operational units',
    tuttiIClienti: 'All clients',
    cercaCliente: 'Search client...',
    reset: 'Reset',
    totaleFatturatiNelPeriodo: 'Total invoiced in period',
    nConversazioni: 'n° conversations:',
    costoAConversazione: 'Cost per conversation:',
    gestiteDaNora: 'Handled by Nora',
    escluseConversazioniInoltrate: '* excluding conversations forwarded to operator',
    nessunaConversazioneNelPeriodo: 'No conversations in period',
    costoTotale: 'Total cost',
    conversazioniTotali: 'Total conversations',
    elaborate: 'Processed:',
    inoltrate: 'Forwarded:',
    // Test/AutoTest
    datiChatNonDisponibili: 'Chat data not available',
    importazioneCompletata: 'Import completed',
    conversazioniInserite: 'conversations inserted',
    saltateGiaPresenti: 'skipped (already present)',
    erroreDuranteImportazione: 'Error during import or test execution:',
    autoTestTitle: 'Auto Test',
    autoTestSubtitle: 'Automated tests to validate data extraction from conversations',
    caricamentoInCorso: 'Loading...',
    caricaTestConv: 'Load TESTCONV.json',
    lanciaTuttiITest: 'Run all tests',
    test: 'Test',
    nessunTestTrovato: 'No test found',
    messaggio: 'Message',
    fileAllegati: 'Attached files',
    allegaFile: 'Attach file',
    messaggioBozzaNora: "Nora's draft message: ",
    copia: 'Copy',
    nessunMessaggio: 'No messages',
    leggiJson: 'Read JSON',
    risultatoElaborazione: 'Processing Result',
    step: 'Step',
    combTariffaCompagniaDuplicata: 'This fare and company combination already exists',
    duplicato: 'Duplicate',
    apriChiudiMenu: 'Open or close navigation menu',
    chiudiMenu: 'Close navigation menu',
    nuovaProposta: 'NEW PROPOSAL',
    formatoDataPlaceholder: 'dd/mm/yyyy',
    executionTime: 'Execution Time',
    // Statistics
    stPresetOggi: 'Today',
    stPreset7Giorni: '7 days',
    stPreset30Giorni: '30 days',
    stPresetQuestoMese: 'This month',
    stPreset3Mesi: '3 months',
    stPresetAnno: 'Year',
    stStatusAperta: 'Open',
    stStatusTerminata: 'Ended',
    stStatusGestitaOperatore: 'Handled by operator',
    stChartTrasferteCreate: 'Created trips',
    stChartInoltrateOperatore: 'Forwarded to operator',
    stChartNoraEsclusa: 'Nora excluded',
    stChartConversazioniIgnorate: 'Ignored conversations',
    stChartInCaricoOperatore: 'Assigned to an operator',
    stChartCorrettamenteGestite: 'Correctly handled',
    stCardElaborate: 'Processed conversations',
    stCardConsegnateGestioneManuale: 'Delivered for manual handling',
    stCardEscluseErrori: 'Excluded / errors',
    stDettagliElaborate: 'Details % processed',
    stDettagliInoltrate: 'Details % forwarded',
    stDettagliErrori: 'Details % errors',
    stPercTotale: '% of total conv.',
    stPeriodoSelezionato: 'Selected period:',
    stDashboardEuro: 'Dashboard €',
    stEsportaReport: 'Export Report',
    stSegnaFatturato: 'Mark as invoiced',
    stPieGenerale: 'General',
    stPieOpenPausa: 'Open or paused',
    stPieErroriGestiti: 'Handled errors',
    stPieNoraEsclusaOp: 'Nora excluded by op.',
    stTornaStatistiche: 'Back to Statistics',
    stCostoConversazioniTempo: 'Conversation cost over time',
    stCostoMedioPeriodo: 'Average cost in period:',
    // Process Performance
    pfStatoProcessi: 'Process status',
    pfProcessiLower: 'processes',
    pfProcessiCreatiPerOra: 'Processes created per hour',
    pfNessunDatoNelPeriodo: 'No data in period',
    pfServerCanali: 'Servers & channels',
    pfStatoInTempoReale: 'Real-time status',
    pfOperatori: 'operators',
    pfTokenMin: 'Token/min',
    pfRichiesteMin: 'Requests/min',
    pfInCoda: 'In queue:',
    pfNessunDatoServer: 'No server data available',
    pfConnSuffix: ' conn.',
    pfLegendaRosso: '- **Red**: `Err% > 10` (many errors).',
    pfLegendaGiallo:
      '- **Yellow**: `P90÷Average ≥ ${threshold}` (high variance: slow tail vs average).',
    pfVarianzaP90Media: 'Variance P90 ÷ Average',
    pfRapportoP90Media: 'Ratio between P90 and the arithmetic mean over the selected period.',
    pfValoriAltiCoda: 'High values indicate a slow tail compared to the average time.',
    pfMediaAssolutaColonne: 'Absolute average and Δ columns (ms)',
    pfBaselineCalcolata:
      'The baseline is computed over the last 12 months of hourly cache, excluding the buckets of the selected period.',
    pfColonneDeltaMostrano:
      'The Δ columns show (period − baseline) in ms: positive = slower, negative = faster.',
    pfAndamentoNelTempo: 'Trend over time',
    pfSelezionaUnitTabella: 'Select unit from the table',
    pfSelezionaUnaPiuUnit: 'Select one or more units from the table to display the chart',
    pfNessunDatoNelPeriodoSelezionato: 'No data in the selected period',
    pfEsecuzioniSommaUnit: 'Executions (unit sum):',
    pfMedia: 'average',
    pfAndamentoGiornaliero: 'Daily trend',
    pfSelezionaUnaPiuUnitGiornaliero: 'Select one or more units for the daily chart',
    pfBarreEsecuzioniLinee: 'Bars: executions · Lines: average time ± standard deviation',
    pfEsecuzioni: 'Executions',
    pfTempoMedioMs: 'Average time (ms)',
    pfEsecuzioniSigmaUnit: 'Executions (Σ unit)',
    pfNessunDatoGiornaliero: 'No daily data in period (try a cache backfill or a wider range)',
    pfTempoMedioPerUnit: 'Average time per unit',
    pfSecondiTop: 'Seconds · top',
    pfDistribuzioneTempiProcessi: 'Process time distribution',
    pfOgniPuntoProcesso: 'Each point is a completed process. Click to open details.',
    pfProcessoHash: 'Process #',
    pfTempo: 'Time: ',
    pfNessunProcessoTempo: 'No process with execution time in the period',
    pfVolumeProcessiPanoramica: 'Process volume · daily overview',
    pfTreViste:
      'Three views over the same range: steps per unit, average times, completed processes',
    pfGrafici12Prime:
      'Charts 1 and 2: top ${max} units by volume in the period out of ${total} total; the stack includes "Other units" for the rest.',
    pfStepPerUnitStack: '1 · Steps per unit (daily stack)',
    pfColonneImpilate:
      'Stacked columns: for each day, how many steps were run for each highlighted unit; the grey band sums the other units.',
    pfAltreUnit: 'Other units',
    pfTempoMedioEsecuzionePerUnit: '2 · Average execution time per unit',
    pfLineeMediaGiornaliera:
      'Lines: daily average of step time; vertical bars ± sample standard deviation.',
    pfStepNelGiorno: 'Steps in day (all units):',
    pfProcessCompletatiPerGiorno: '3 · Processes completed per day',
    pfConteggioProcessEndTime:
      'Count of processes with endTime in the day and state 3 (ok) or 5 (error). Days with no closures show 0.',
    pfProcess: 'Process',
    pfProcessCompletati: 'Completed processes',
    pfNessunGiornoNelRange: 'No day in range',
    pfMediaRecente: 'Recent average',
    pfBaseline: 'Baseline',
    pfRapporto: 'Ratio',
    pfErroriRecenti: 'Recent errors: ',
    pfBaselineInfix: ' (baseline: ',
    pfTuttiSistemiNormali: 'All systems operating normally',
    pfAnomalieRilevate: 'anomalies detected',
    pfVistaForm: 'Form view',
    pfVistaJson: 'JSON view',
    pfRieseguiUnit: 'Re-run unit',
    pfConfermaRieseguiUnit:
      'Do you want to re-run this unit with the initial state of the selected step?',
    pfStepPrecedente: 'Previous step',
    pfStepSuccessivo: 'Next step',
    pfRisultatoPrecedente: 'Previous',
    pfRisultatoSuccessivo: 'Next',
    pfCerca: 'Search...',
    pfToken: 'Token ',
    tutteEsecuzioni: 'All',
    nessunErroreTrovato: 'No errors found in the period',
    nomeProcesso: 'Name',
    ggRoomSingola: 'Single (1 adult)',
    ggRoomDoppia: 'Double (2 adults)',
    ggRoomTripla: 'Triple (3 adults)',
    ggComposizioneCamere: 'Room composition',
    ggAggiungiOpzione: 'Add option',
    ggNessunaPreferenzaCamere: 'No room preference (defaults will be used)',
    ggOpzione: 'Option',
    ggCamera: 'Room',
    ggTipoCamera: 'Room type',
    ggCampiPersonalizzati: 'CUSTOM FIELDS',
    ggErroreRicercaCliente: 'Client search error',
    ggPulisci: 'Clear',
    ggNessunaOpzione: 'No options available',
    gfMonthNames: [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December'
    ],
    gfDayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    admDisabilitato: 'Disabled',
    admSezioneInfoBase: 'Basic information',
    admSezioneImpostazioniAI: 'AI settings',
    admSezioneIntegrazioneB4B: 'B4B integration',
    admSezioneIntegrazioneAtlante: 'Atlante integration',
    admSezioneIntegrazioneDinamico: 'Dynamic integration (PHP and WSDynPkg)',
    admSezioneEmailComunicazioni: 'Email & communications',
    admCreaSocieta: 'Create new company',
    admModificaSocieta: 'Edit company',
    admSottotitoloSocieta: 'Configure the settings and integrations for the company',
    admEspandiTutto: 'Expand all',
    admChiudiTutto: 'Collapse all',
    admUsername: 'Username',
    admPassword: 'Password',
    admIdEnvironment: 'Environment Id',
    admRuolo: 'Role',
    admAnagraficaUtente: 'User details',
    admCreaUtente: 'Create user',
    admModificaUtente: 'Edit user',
    admPID: 'PID',
    admEmail: 'Email',
    admTelefono: 'Phone',
    admNome: 'First name',
    admCognome: 'Last name',
    admAnagraficaViaggiatore: 'Traveler details',
    admCreaViaggiatore: 'Create traveler',
    admModificaViaggiatore: 'Edit traveler',
    admImportaViaggiatori: 'Import travelers',
    admSottotitoloImport: 'Upload a CSV file to bulk-import the travelers registry',
    admCaricaCSV: 'Upload CSV',
    admCaricaSuDB: 'Upload to DB',
    admAnteprimaFile: 'Uploaded file preview',
    admViaggiatoriDaImportare: ' travelers to import',
    admNienteDaVisualizzare: 'Nothing to display',
    admTutorialUpload: 'Upload a CSV file containing the travelers to add.',
    admTutorialStruttura: 'The CSV file must be structured as follows: ',
    admTutorialIntestazione:
      'The first header row must contain the fields pid, email, phone number, client code.',
    admTutorialDati: 'From the second row onward, enter the data for the various clients.',
    admTutorialEsempio: 'Here is a sample file to edit and upload.',
    admScarica: 'Download',
    admAggiornaLabelErrori: 'Update error labels',
    admAggiornaLabelErroriHint:
      'Update the error label to categorize them with the latest version of the classifier.',
    admAggiornaErroriTAProfile: 'Update TA profile errors',
    admAggiornaErroriTAProfileHint:
      'Recompute errors related to the TA profile (travelers registry).',
    admAggiornaErroriOutOfOffice: 'Update out-of-office errors',
    admAggiornaErroriOutOfOfficeHint: 'Update the classification of out-of-office emails.',
    admSottotitoloPanel: 'Data maintenance operations',
    admOperazioniManutenzione: 'Maintenance operations',
    admSottotitoloManutenzione: 'Run them carefully · irreversible actions',
    admEsegui: 'Run',
    controlliIA: 'AI Checks',
    cpDuplica: 'Duplicate',
    cpSottotitoloPanel: 'Community Panel · Nora configuration preset',
    cpAggiungiFiltri: 'Add filters',
    cpAggiungiFiltro: 'Add filter…',
    cpNRimborsabili: 'No. refundable',
    cpNNonRimborsabili: 'No. non-refundable',
    cpInserisciParametroRicerca: 'Enter at least one search parameter',
    cpErroreRicercaGruppo: 'Error searching for the group',
    cpGruppoNonTrovato: 'Group not found',
    cpPresetEsistente: 'Existing preset',
    cpGruppoConfigurazioneEsistente: 'This group already has a saved configuration',
    cpClienteNonTrovato: 'Client not found',
    cpClienteConfigurazioneEsistente: 'This client already has a saved configuration',
    cpCreaPreset: 'Create Community Preset',
    cpModificaPreset: 'Edit Community Preset',
    mxElencoPrompts: 'Prompts list',
    mxPromptLLMSubtitle: 'LLM prompts used to extract conversation fields',
    mxCompilaCampi: 'Fill in all fields',
    mxPromptCreato: 'Prompt created',
    mxCreazionePrompt: 'Create Prompt',
    mxModificaPrompt: 'Edit Prompt',
    mxConfigurazionePrompt: 'Prompt configuration',
    mxChiaveCampoJson: 'JSON field key',
    mxSpiegazioneCampo: 'Field explanation (basePrompt)',
    mxValidaTestLabel: 'Do you want to validate the test? The autotest result will be updated',
    mxTestIdPrefix: 'Test ID: ',
    mxValidazioneEstrazione: 'Conversation data extraction validation',
    mxTestPrecedente: 'Previous test',
    mxTestSuccessivo: 'Next test',
    mxEseguiTest: 'Run Test',
    mxValidaTest: 'Validate Test',
    mxConversazioneTest: 'Test conversation',
    mxMessaggiSuffix: ' messages',
    mxRisultatoAtteso: 'Expected result',
    mxRisultatoOttenuto: 'Obtained result',
    mxInEsecuzione: 'Running',
    mxImpostazioneCoefficienti: 'Search coefficients setting',
    mxImpostaCoefficientiPer: 'Set coefficients for ',
    mxTipoPreventivo: 'Quote type '
  }
}
